import React, { useState, useEffect, useCallback, useRef } from "react";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import {
  Avatar,
  SelectPicker,
  DatePicker,
  Drawer,
  Placeholder,
  Whisper,
  Button,
  Popover,
  Stack,
  Message,
  useToaster,
  Tooltip,
  Input,
  Loader,
  Modal,
  Uploader,
  Progress,
} from "rsuite";
import "rsuite/SelectPicker/styles/index.css";
import { json, Link } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import debounce from "lodash.debounce";
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";

import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";
import IconEye from "../images/iconEye.svg";
import IconInfo1 from "../images/Icon_Info.svg";

import { parsePhoneNumberFromString } from "libphonenumber-js";
import IconRefresh from "../images/iconRefresh.svg";
import { encryptData, decryptData } from "./cryptoUtil";
import moment from "moment-timezone";
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";
import { CircleFlag } from "react-circle-flags";
import LoaderFull from "../component/Loader";
import IconNoComment from "../images/noComment.svg";
import iconNotes from "../images/iconNotes.svg";
import Football from "../images/football-kicking.gif";
import countryTz from "country-tz";
import Babuddin from "../images/Babuddin.jpg";
import iconUpload from "../images/iconUpload.svg";

import iconJPG from "../images/iconJPG.svg";
import iconPNG from "../images/iconPNG.svg";
import iconPDF from "../images/iconPDF.svg";
import iconCancel from "../images/iconCancel.svg";
import iconUploadbtn from "../images/icon-btn-upload.svg";

import iconList from "../images/log-activity-icons/iconList.svg";
import iconCall from "../images/log-activity-icons/iconCall.svg";
import iconEmail from "../images/log-activity-icons/iconMail.svg";
import iconSms from "../images/log-activity-icons/iconSMS.svg";
import iconWhatsapp from "../images/log-activity-icons/iconWhatsapp.svg";
import iconMeeting from "../images/log-activity-icons/iconMeeting.svg";

import iconDropArrow from "../images/log-activity-icons/iconDropArrow.svg";
import iconCollapseArrow from "../images/log-activity-icons/iconCollapseArrow.svg";

const icons = {
  Task: iconList,
  Call: iconCall,
  Email: iconEmail,
  SMS: iconSms,
  Whatsapp: iconWhatsapp,
  Meeting: iconMeeting,
  Summit: iconMeeting,
};

const typeColors = {
  Task: "#C032B2", // Gray
  Call: "#1FB16E", // Blue
  Email: "#5CABF3", // Teal
  SMS: "#FF9012", // Orange
  Whatsapp: "#1FB16E", // WhatsApp Green
  Meeting: "#F03D3D", // Purple
  Summit: "#F03D3D", // Green
};

function Leads(props) {
  const [tabName, setTabName] = useState("Dealmaker Leads");

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const timeZone = "Asia/Kolkata";

  const orderData = ["ASC", "DESC"].map((item) => ({
    label: item,
    value: item,
  }));

  const CBAStatus = ["Pass", "Fail"].map((item) => ({
    label: item,
    value: item,
  }));

  const statusData = [
    { label: "Publish", value: true },
    { label: "UnPublish", value: false },
    { label: "Both", value: "" },
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  const toast = useToast();
  const toastIdRef = React.useRef();

  const abortControllerRef = useRef(null);
  const [isLoading, setLoading] = useState(false); // State to manage loading state
  const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state

  const abortControllerRefGlobal = useRef(null);
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportdata, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [progressId, setProgressId] = useState("");
  const [scoreId, setScoreId] = useState("");

  const [orderBy, setOrderBy] = useState("id"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order

  const [statusId, setStatusId] = useState();
  const [subscriptionId, setSubscriptionId] = useState();
  const [searchInput, setSearchInput] = useState("");

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [CMPTminValue, setCMPTMinValue] = useState("");
  const [CMPTmaxValue, setCMPTMaxValue] = useState("");

  const [NCMPTminValue, setNCMPTMinValue] = useState("");
  const [NCMPTmaxValue, setNCMPTMaxValue] = useState("");

  const [DBFTminValue, setDBFTMinValue] = useState("");
  const [DBFTmaxValue, setDBFTMaxValue] = useState("");

  const [IntrestminValue, setIntrestMinValue] = useState("");
  const [IntrestmaxValue, setIntrestMaxValue] = useState("");

  const [DEBTminValue, setDEBTMinValue] = useState("");
  const [DEBTmaxValue, setDEBTMaxValue] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [assignUserid, setAssignUserid] = useState("");

  const [complianceData, setComplianceData] = useState([]);

  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = sessionStorage.getItem("userId");
  const [refreshKey, setRefreshKey] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");
  const [messageType, setMessageType] = useState(null); // success, error, info
  const [assetClassData, setAssetClassData] = useState([]);
  const [searchAsset, setSearchAsset] = useState("Equity");

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);

  const [filterDate, setFilterDate] = useState(null);

  const [UTMSourceData, setUTMSourceData] = useState([]);
  const [UTMSourceId, setUTMSourceId] = useState("");

  useEffect(() => {
    const fetchUTMSourceList = async () => {
      const url = `${apiEndPoint}/utm_source`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        const formattedUTMSourceData = data.data.map((utmSource) => ({
          label: utmSource.utm_source,
          value: utmSource.utm_source,
        }));

        setUTMSourceData(formattedUTMSourceData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchUTMSourceList();
  }, []);

  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons

    setOrderBy(columnName);

    switch (columnName) {
      case "created_at":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "investment_amount":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }
  };

  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/country_master`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchCountryList();
  }, []);

  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/baraka_users`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        console.log("A" + JSON.stringify(data));

        const formattedUserData = data.data.map((user) => ({
          label: user.fullname,
          value: user.id,
          profile_img: user.profile_img,
        }));

        setUserData(formattedUserData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchCountryList();
  }, []);

  const fetchGlobalReport = async () => {
    setGlobalLoading(true);

    // Cancel the previous request if any
    if (abortControllerRefGlobal.current) {
      abortControllerRefGlobal.current.abort();
    }

    const controller = new AbortController();
    abortControllerRefGlobal.current = controller;

    // -------- STEP 1: Fetch Column Order --------
    let finalColumnOrder = [];

    try {
      const columnOrderResponse = await fetch(
        `${apiEndPoint}/user_column_order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              user_id: userid,
              module: "leads",
            },
          }),
          signal: controller.signal,
        }
      );

      const columnOrderResult = await columnOrderResponse.json();
      const parsedOrder = columnOrderResult.data?.[0]?.column_order;

      if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
        const activeColumns = parsedOrder
          .filter((col) => col.is_active)
          .map((col) => ({
            name: col.name || "",
            isDraggable: col.isDraggable ?? col.is_draggable ?? true,
          }));

        if (activeColumns.length > 0) {
          finalColumnOrder = activeColumns;
        } else {
          finalColumnOrder = defaultColumns.map((name) => ({
            name,
            isDraggable: true,
          }));
        }
      } else {
        finalColumnOrder = defaultColumns.map((name) => ({
          name,
          isDraggable: true,
        }));
      }
    } catch (error) {
      console.error("Column order fetch failed:", error);
      finalColumnOrder = defaultColumns.map((name) => ({
        name,
        isDraggable: true,
      }));
    }

    setColumnOrder(finalColumnOrder);

    // -------- STEP 2: Fetch Leads Data --------
    try {
      const zonedDate = moment(filterDate).isValid()
        ? moment(filterDate).tz(timeZone).format()
        : "";

      const requestData = encryptData({
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput || "",
          order,
          country: countryCode || "",
          orderBy,
          status: progressId,
          filter_date: zonedDate || "",
          payment_status: statusId,
          app_role: subscriptionId,
          score_from: scoreFrom,
          score_to: scoreTo,
          utm_source: UTMSourceId,
        },
      });

      const response = await fetch(`${apiEndPoint}/leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
        signal: controller.signal,
      });

      const jsonData = await response.json();
      const decrypted = decryptData(jsonData);

      setGlobalLoading(false);
      setReportCount(decrypted.count);
      setReportData(decrypted.data);
    } catch (error) {
      if (error.name !== "AbortError") {
        setGlobalLoading(false);
        setErrorMessage(error.message);
        setMessageType("error");
      }
    }
  };

  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 1000),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [
    currentPage,
    countryCode,
    pageRange,
    filterDate,
    progressId,
    order,
    orderBy,
    statusId,
    subscriptionId,
    refreshKey,
    scoreId,
    UTMSourceId,
  ]); // Regular effect for other dependencies

  const handleSearch = (event) => {
    console.log(event.target.value);

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 1000), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav
        aria-label="..."
        id="pagination_row"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          background: "#FFF",
          paddingTop: 0,
          paddingBottom: 0,
          zIndex: 3,
          marginBottom: 10,
        }}
      >
        <div className="totalRecords">
          Total Records : {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: "none" }}>
          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker
              onChange={handlePagelimit}
              cleanable={false}
              value={pageRange}
              placement="top"
              placeholder="Pages"
              data={PagingData}
              searchable={false}
              style={{
                width: 85,
                height: 35,
                display: "flex",
                alignItems: "center",
                borderRadius: 5,
                border: "1px solid #A1B9ED",
              }}
            />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li
            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
            style={{ marginLeft: 10 }}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            >
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <a
                className="page-link"
                href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
            >
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            style={{ marginRight: 10 }}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(totalPages)}
            >
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li
            className="page-item"
            style={{
              marginLeft: 10,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              style={{
                padding: "0px 10px",
                color: "#878787",
                fontSize: 16,
                borderRadius: 5,
                border: "1px solid #A1B9ED",
                width: 60,
                height: 35,
                textAlign: "center",
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };

  // PAGINATION
  const PagingData = ["10", "20", "50", "100"].map((item) => ({
    label: item,
    value: item,
  }));

  const handleClearFilters = () => {
    setCurrentPage(1);
    setSearchInput("");
    setSearchAsset("");
    setCountryCode("");
    setStatusId("");
    setSubscriptionId("");
    setComplianceId("");
    setOrder("");
    setProgressId("");
    setScoreId("");
    setFilterDate(null);
    setScoreFrom(null);
    setScoreTo(null);
  };

  const handleAssetClass = (value) => {
    setSearchAsset(value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const handleCountryChange = (value) => {
    setCurrentPage(1);
    setCountryCode(value);
  };

  const handleStatusChange = (value) => {
    setStatusId(value);
  };

  const handleSubscription = (value) => {
    setSubscriptionId(value);
  };

  const handleComplianceChange = (value) => {
    setCurrentPage(1);
    setComplianceId(value);
  };

  const handleProgressStatus = (value) => {
    setCurrentPage(1);
    setProgressId(value);
  };

  const handleUTMSource = (value) => {
    setCurrentPage(1);
    setUTMSourceId(value);
  };

  const handleScoreStatus = (value) => {
    setCurrentPage(1);

    if (!value) {
      setScoreId(null);
      setScoreFrom(null);
      setScoreTo(null);
      return;
    }

    setScoreId(value);

    // Remove $ and +, then split by '-'
    //const cleanedValue = value.split("-");
    const cleanedValue = value.split(/[-–—]/); // splits on hyphen, en dash, or em dash
    let scoreFrom = null;
    let scoreTo = null;

    scoreFrom = parseInt(cleanedValue[0].replace(/,/g, "").trim(), 10);
    scoreTo = parseInt(cleanedValue[1].replace(/,/g, "").trim(), 10);

    console.log("scoreFrom : " + scoreFrom);
    console.log("scoreTo : " + scoreTo);

    // Set your state values
    setScoreFrom(scoreFrom);
    setScoreTo(scoreTo);
  };

  const handleorderChange = (value) => {
    setCurrentPage(1);
    setOrder(value);
  };

  const [openDeletePopover, setOpenDeletePopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.Symbol);
    if (openDeletePopover === item.id) {
      setOpenDeletePopover(null); // Close the popover if it's already open
    } else {
      setOpenDeletePopover(item.id); // Open the popover
    }
  };

  // // Function to handle deletion confirmation
  // const handlePublishConfirm = (Symbol) => {

  //     console.log(`Publish report with Symbol: ${Symbol}`);
  //     setOpenDeletePopover(null); // Close the popover after confirmation
  // };

  const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);

    // Prepare the data to be sent in the API request
    const requestData = {
      data: {
        user_id: userid, // Replace with actual user_id if needed
        symbol: item.Symbol, // Use the symbol passed to the function
        publish: item.Published ? "false" : "true",
      },
    };

    setOpenDeletePopover(null); // Close the popover after confirmation
  };

  // Store last known order in a ref or state, including hidden columns
  const [columnOrder, setColumnOrder] = useState([]);
  const [fullColumnOrder, setFullColumnOrder] = useState([]);

  // Populate fullColumnOrder initially
  useEffect(() => {
    setFullColumnOrder((prev) => {
      // Only set if it's empty (i.e., first load)
      return prev.length === 0 ? columnOrder : prev;
    });
  }, [columnOrder]);

  const handleCheckboxChange = async (columnName, isChecked) => {
    setColumnOrder((prevColumnOrder) => {
      // Step 1: Create a map of current states (from fullColumnOrder and prevColumnOrder)
      const currentColumnStates = new Map();

      fullColumnOrder.forEach((col) => {
        currentColumnStates.set(col.name, {
          is_active: col.is_active ?? true,
          is_draggable: col.is_draggable ?? col.isDraggable ?? true,
        });
      });

      prevColumnOrder.forEach((col) => {
        currentColumnStates.set(col.name, {
          is_active: col.is_active ?? true,
          is_draggable: col.is_draggable ?? col.isDraggable ?? true,
        });
      });

      // Step 2: Build the updated full column list
      const updatedColumnOrder = fullColumnOrder.map((col) => {
        const currentState = currentColumnStates.get(col.name);

        return {
          name: col.name,
          is_active:
            col.name === columnName
              ? isChecked
              : currentState?.is_active ?? true,
          is_draggable:
            currentState?.is_draggable ??
            col.is_draggable ??
            col.isDraggable ??
            true,
        };
      });

      // Step 3: Update full state and call API
      setFullColumnOrder(updatedColumnOrder);
      saveColumnOrderToAPI(updatedColumnOrder);

      // Step 4: Return only active columns for UI state
      return updatedColumnOrder.filter((col) => col.is_active);
    });
  };

  const saveColumnOrderToAPI = async (updatedColumnOrder) => {
    try {
      const cleanedPayload = updatedColumnOrder.map((col) => ({
        name: col.name,
        is_active: col.is_active,
        is_draggable: col.is_draggable,
      }));

      const response = await fetch(`${apiEndPoint}/update_user_column_order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            module: "leads",
            column_order: cleanedPayload,
          },
        }),
      });

      fetchGlobalReport();

      if (!response.ok) throw new Error("Failed to save column order");
      const result = await response.json();
      // console.log("Column order updated successfully", result);
    } catch (error) {
      console.error("Error updating column order:", error);
    }
  };

  // Mapping between checkbox IDs and their corresponding column names
  const checkboxColumnMap = {
    Email: "Email Address",
    PhoneNumber: "Phone Number",
    CountryofResidence: "Country",
    LocalTime: "Local Time",
    InvestmentLikelihoodScore: "Likehood Score",
    PlatformRegistrationDate: "Date Invited",
    InvestmentInviteDate: "Investment Invite Date",
    InvestmentInterestAmount: "Investment Amount",
    AssignedUser: "Assigned User",
    IRNotes: "IR Notes",
    Source: "Source",
    LeadStatus: "Status",
    ProgressState: "Progress State",
    CheckStatus: "Check Status",
    LeadOwner: "Payment",
    PlatformUserMatch: "Web User",
    "App/WebUsageDetected": "Plateform Usage",
    TimeOfInvite: "Time of Invite",
    SharePrice: "Share Price",
    Shares: "Shares",
    TimeBasedBonus: "Time Based Bonus",
    AmountBasedBonus: "Amount Based Bonus",
    ExistingInvestorBonus: "Existing Investor Bonus",
    PremiumSubscriptionBonus: "Premium Subscription Bonus",
    TotalBonus: "Total Bonus",
    AccreditedInvestorStatus: "Accredited",
    Notes: "Notes",
    Address: "Address",
    TimeSinceSubscription: "Time Since Subscription",
    UTMSource: "UTM Source",
    UTMMedium: "UTM Medium",
    UTMCampaign: "UTM Campaign",
    Certificate: "Certificate",
  };

  const handleReset = () => {
    // Create reset columns with all columns active and draggable
    const fullResetColumns = defaultColumns.map((name) => ({
      name,
      is_active: true,
      is_draggable: true,
    }));

    // Update both states
    setColumnOrder(fullResetColumns);
    setFullColumnOrder(fullResetColumns);

    // Save to API - this will send all columns with is_active: true and is_draggable: true
    saveColumnOrderToAPI(fullResetColumns);
  };

  const defaultColumns = [
    "Action",
    "Lead ID",
    "Full Name",
    "Email Address",
    "Phone Number",
    "Country",
    "Local Time",
    "Likehood Score",
    "Date Invited",
    "Time to First Contact",
    "Investment Amount",
    "Assigned User",
    "IR Notes",
    "Source",
    "Status",
    "Progress State",
    "Check Status",
    "Payment",
    "Web User",
    "Plateform Usage",
    "Time of Invite",
    "Time Since Subscription",
    "Share Price",
    "Shares",
    "Time Based Bonus",
    "Amount Based Bonus",
    "Existing Investor Bonus",
    "Premium Subscription Bonus",
    "Total Bonus",
    "Accredited",
    "Notes",
    "Address",
    "UTM Source",
    "UTM Medium",
    "UTM Campaign",
    "Certificate",
  ];

  // ✅ Save Column Order (separate API)
  const saveColumnOrder = async (newOrder) => {
    try {
      const formattedOrder = newOrder.map((col) => ({
        name: col.name,
        is_active: true,
        is_draggable: col.isDraggable ?? true,
      }));

      const response = await fetch(`${apiEndPoint}/update_user_column_order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            module: "leads",
            column_order: formattedOrder,
          },
        }),
      });

      if (!response.ok) throw new Error("Failed to save column order");

      const result = await response.json();
      // ✅ Important: Update fullColumnOrder too!
      const updatedFullColumnOrder = formattedOrder.map((col) => ({
        ...col,
        is_active: col.is_active,
        is_draggable: col.is_draggable,
      }));

      setFullColumnOrder(updatedFullColumnOrder);

      // ✅ Also update visible columns
      setColumnOrder(updatedFullColumnOrder.filter((col) => col.is_active));

      // Optionally re-fetch data
      fetchGlobalReport();

      // console.log("Column order saved successfully:", result);
    } catch (error) {
      console.error("Error saving column order:", error);
    }
  };

  // REODER DRAG COLUMNS
  useEffect(() => {
    // console.log("Column Order Set:", columnOrder);
  }, [columnOrder]);

  const [open, setOpen] = useState(false);
  const [CMPTopen, setCMPTOpen] = useState(false);
  const [NCMPTopen, setNCMPTOpen] = useState(false);
  const [DBFTopen, setDBFTOpen] = useState(false);
  const [Intrestopen, setIntrestOpen] = useState(false);
  const [DEBTopen, setDEBTOpen] = useState(false);

  //const toggleDropdown = () => setOpen(!open); // Toggle dropdown visibility
  const preventClose = (e) => e.stopPropagation();

  const deleteComment = async (item) => {
    setCommentBoxOpen(true);

    const requestData = encryptData({
      data: {
        user_id: userid,
        comment_id: item.id,
        investor_id: item.investor_id,
      },
    });

    console.log(JSON.stringify(requestData));

    try {
      const response = await fetch(`${apiEndPoint}/delete_comment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const data = await response.json();
      const decrypted = decryptData(data);
      console.log(JSON.stringify(data));
      if (decrypted.status == "success") {
        console.log("Count:", decrypted.count);
        console.log("MESSAGE : " + JSON.stringify(decrypted.data));
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        console.log("Response data:", data);
      }
    } catch (error) {
      console.error(
        "There was a problem with the fetch operation:",
        error.message
      );
    }
  };

  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    }

    switch (messageType) {
      case "success":
        return (
          <Message
            type="success"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_success">
                <div className="icon_error_msg_inner Icon_success_inner">
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_success_text">
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "error":
        return (
          <Message
            type="error"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_error">
                <div className="icon_error_msg_inner Icon_error_inner">
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_error_text">
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "info":
        return (
          <Message
            type="info"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_info">
                <div className="icon_error_msg_inner Icon_info_inner">
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_info_text">
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };

  const hideMessage1 = () => {
    setMessageType1(null);
  };

  const renderMessage1 = () => {
    if (messageType1) {
      setTimeout(hideMessage1, 4000);
    }

    switch (messageType1) {
      case "success":
        return (
          <Message
            type="success"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_success">
                <div className="icon_error_msg_inner Icon_success_inner">
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_success_text">
                <h5>Success</h5>
                <p>{errorMessage1}</p>
              </div>
            </div>
          </Message>
        );
      case "error":
        return (
          <Message
            type="error"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_error">
                <div className="icon_error_msg_inner Icon_error_inner">
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_error_text">
                <h5>Error</h5>
                <p>{errorMessage1}</p>
              </div>
            </div>
          </Message>
        );
      case "info":
        return (
          <Message
            type="info"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_info">
                <div className="icon_error_msg_inner Icon_info_inner">
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_info_text">
                <h5>Info</h5>
                <p>No reports found for the selected priority</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };

  // MODAL

  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [editModalETFName, setEditModalETFName] = useState("");
  const [editModalETFSymbol, setEditModalSymbol] = useState("");
  const etfModelCommentRef = useRef(null);
  const [etfModelPublicComment, setEtfModelPublicComment] = useState("");
  const [assignUserComment, setAssignUserComment] = useState("");
  const [etfModelPrivateComment, setEtfModelPrivateComment] = useState("");
  const [isModalETFLoading, setIsModalETFLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedInvestorId, setSelectedInvestorId] = useState();
  const [selectedFileInvestorId, setSelectedFileInvestorId] = useState();
  const [scoreFrom, setScoreFrom] = useState(null);
  const [scoreTo, setScoreTo] = useState(null);

  const fetchReassignHistory = async (item) => {
    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: item.id,
      },
    });

    try {
      const response = await fetch(`${apiEndPoint}/reassign_history`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const data = await response.json();
      const decrypted = decryptData(data);

      if (decrypted.status == "success") {
        console.log("Count:", decrypted.count);
        console.log("Data:", decrypted.data);

        setReassignCount(decrypted.count);
        setReassignHistory(decrypted.data);
      } else {
        setReassignCount(0);
        setReassignHistory([]);
        console.error("Error:", decrypted.message);
      }
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };

  const handleEditModalOpen = (item) => {
    setAssignUserid(item.user_in_charge_id);
    setAssignUserComment(item.user_comment);
    setSelectedInvestorId(item.id);
    setEditModalOpen(true);

    fetchReassignHistory(item);
  };
  const handleEditModalClose = () => setEditModalOpen(false);

  // const StatusData = ['Compliant', 'Non- Compliant', 'Doubtful', 'Uncovered'].map(
  //     item => ({ label: item, value: item })
  // );
  //const StatusData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: { 'Compliant': 'COMPLIANT', 'Non- Compliant': 'NON_COMPLIANT', 'Doubtful': 'QUESTIONABLE', 'Uncovered': 'NOT_UNDER_COVERAGE' }[item] }));

  //const CountryData = ['India', 'Saudi Arabia', 'USA', 'UAE', 'Pakistan'].map(item => ({ label: item, value: item }));

  const MembersData = [
    "Zain Shaikh",
    "Sana Rizvi",
    "Ali Noor",
    "Rehan Qureshi",
    "Nida Sheikh",
  ].map((item) => ({ label: item, value: item }));

  const FundedStatusData = [
    { label: "Funded", value: "funded" },
    { label: "Un Funded", value: "unfunded" },
  ];

  const subscriptionData = [
    { label: "Freemium", value: "FREEMIUM" },
    { label: "Premium", value: "PREMIUM" },
    { label: "Premium Plus", value: "PREMIUM_PLUS" },
    { label: "Starter", value: "STARTER" },
    { label: "Others", value: "OTHERS" },
  ];

  const SharesData = ["0 - 100", "101 - 500", "501 - 1,000"].map((item) => ({
    label: item,
    value: item,
  }));

  const progressStatus = [
    "Offline",
    "Online",
    "Signed",
    "Waiting",
    "Invited",
    "Accepted",
    "Inactive",
    "Progress",
  ].map((item) => ({ label: item, value: item }));

  const ScoreStatus = ["85–100", "70–84", "50–69", "0–49"].map((item) => ({
    label: item,
    value: item,
  }));

  const StatusData1 = [
    "Committed",
    "Funded",
    "Interest Express",
    "Cancelled",
    "Completed",
  ].map((item) => ({ label: item, value: item }));

  useEffect(() => {
    if (etfModelCommentRef.current) {
      etfModelCommentRef.current.value = etfModelPublicComment;
    }
  }, [etfModelPublicComment]);

  const handleReassignSave = async () => {
    if (!assignUserid || assignUserid == 0) {
      toastIdRef.current = toast({
        description: "Please Select User",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return false;
    }

    try {
      setLoading(true);
      const apiUrl = `${apiEndPoint}/reassign_user`;
      const requestData = encryptData({
        data: {
          investor_id: selectedInvestorId,
          new_user_assign_id: assignUserid,
          updated_by: userid,
          comment: assignUserComment,
        },
      });

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      const jsonData = await response.json();
      const decrypted = decryptData(jsonData);

      if (decrypted.status == "success") {
        setLoading(false);
        setRefreshKey((prev) => prev + 1);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setEditModalOpen(false);
      } else {
        setLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;
      }
    } catch (error) {
      setLoading(false);
      toastIdRef.current = toast({
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return false;
    }
  };

  const handleManualReset = async () => {
    setIsModalETFLoading(true);
  };

  const handleFilterDateChange = (value) => {
    setCurrentPage(1);

    setFilterDate(value);
  };

  const handleUserChange = (selectedOption) => {
    setAssignUserid(selectedOption); // Update selectedPeriod state with the selected option
  };

  const handleETFStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
  };

  const triggerRef = React.useRef();
  const openUncovered = () => triggerRef.current.openUncovered();
  const closeUncovered = () => triggerRef.current.closeUncovered();

  // TRUNCATE
  function truncateText(text, maxLength = 14) {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function address__truncate(text, maxLength = 22) {
    if (typeof text !== "string") return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function notes__truncate(text, maxLength = 30) {
    if (typeof text !== "string") return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  const [expandedRowId, setExpandedRowId] = useState(null);

  const handleRowClick = (id) => {
    console.log(expandedRowId + " : " + id);
    if (expandedRowId == id) {
      setExpandedRowId(null);
    } else {
      // Toggle the expanded row
      setExpandedRowId(id);
      //setExpandedRowId(prevId => (prevId === id ? null : id));
    }
  };

  const [draggedColumn, setDraggedColumn] = useState(null);

  const handleDragStart = (e, col) => {
    setDraggedColumn(col);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#FFD791";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = col;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // const handleDrop = (e, targetCol) => {
  //   e.preventDefault();
  //   const fromIndex = columnOrder.indexOf(draggedColumn);
  //   const toIndex = columnOrder.indexOf(targetCol);

  //   if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

  //   const newOrder = [...columnOrder];
  //   const [moved] = newOrder.splice(fromIndex, 1);
  //   newOrder.splice(toIndex, 0, moved);

  //   const thElements = document.querySelectorAll("th");
  //   const tdElements = document.querySelectorAll("tbody tr");

  //   // FLIP: First — Get starting positions
  //   const firstPositions = {};
  //   columnOrder.forEach((key) => {
  //     const th = document.querySelector(`th[data-column-id="${key}"]`);
  //     if (th) firstPositions[key] = th.getBoundingClientRect().left;
  //   });

  //   setColumnOrder(newOrder); // Update DOM

  //   // Wait for re-render
  //   requestAnimationFrame(() => {
  //     // Animate headers (FLIP)
  //     newOrder.forEach((key) => {
  //       const th = document.querySelector(`th[data-column-id="${key}"]`);
  //       const oldX = firstPositions[key];
  //       if (!th || oldX === undefined) return;

  //       const newX = th.getBoundingClientRect().left;
  //       const dx = oldX - newX;

  //       if (dx !== 0) {
  //         th.style.transform = `translateX(${dx}px)`;
  //         th.classList.add("animating");

  //         requestAnimationFrame(() => {
  //           th.style.transform = "";
  //         });

  //         setTimeout(() => {
  //           th.classList.remove("animating");
  //         }, 400);
  //       }
  //     });

  //     // Animate movedColumn cells
  //     const movedColumn = draggedColumn; // dynamically get the dragged column id
  //     const cells = document.querySelectorAll(`[data-column-id="${movedColumn}"]`);
  //     cells.forEach((cell) => {
  //       void cell.offsetWidth; // force reflow to restart animation
  //       cell.classList.add("column-drop-animate");
  //     });

  //     setTimeout(() => {
  //       cells.forEach((cell) => {
  //         cell.classList.remove("column-drop-animate");
  //       });
  //     }, 850);

  //   });

  //   setDraggedColumn(null);
  // };

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow drop
  };

  // 🟩 Drag end
  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  const handleDrop = (e, targetColumnKey) => {
    // console.log("Drop event triggered for column:", targetColumnKey);
    e.preventDefault();

    const draggedIndex = columnOrder.findIndex(
      (col) => col.name === draggedColumn
    );
    const targetIndex = columnOrder.findIndex(
      (col) => col.name === targetColumnKey
    );

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn(null);
      return;
    }

    // Temporarily disable scrollbar during animation
    const tableContainer = document.querySelector(".table").closest("div");
    if (tableContainer) {
      tableContainer.style.overflowY = "hidden";
    }

    const newColumnOrder = [...columnOrder];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder(newColumnOrder);
    setDraggedColumn(null);
    saveColumnOrder(newColumnOrder);

    // Apply drop animation with performance optimizations
    requestAnimationFrame(() => {
      // Find all cells with the movedColumn's data-column-id
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn.name}"]`
      );

      // Get current table height to lock it during animation
      const table = document.querySelector("table");
      const tableHeight = table.offsetHeight;
      table.style.height = `${tableHeight}px`;

      cells.forEach((cell) => {
        // Force reflow to ensure animation restarts
        void cell.offsetWidth;
        cell.classList.add("column-drop-animate");
      });

      // Cleanup after animation completes
      setTimeout(() => {
        cells.forEach((cell) => {
          cell.classList.remove("column-drop-animate");
        });

        // Release table height constraint
        table.style.height = "";

        // Re-enable vertical scrolling if needed
        if (tableContainer) {
          tableContainer.style.overflowY = "";
        }

        // Optional: Highlight the table
        table.classList.add("table-highlight-column");
        setTimeout(() => {
          table.classList.remove("table-highlight-column");
        }, 600);
      }, 850); // Slightly longer than animation duration
    });
  };

  const [open2, setOpen2] = useState(false);

  const handleOpenDrawer = () => setOpen2(true);
  const handleCloseDrawer = () => setOpen2(false);

  function formatPhoneNumberGlobal(rawNumber) {
    if (!rawNumber) return rawNumber;
    const phoneNumber = parsePhoneNumberFromString(rawNumber);
    return phoneNumber
      ? phoneNumber.formatInternational().replace(/\s+/g, "-")
      : rawNumber;
  }

  //COMMENT MODAL
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentFetchTextValue, setCommentFetchTextValue] = useState("");
  const [commentFieldId, setCommentFieldId] = useState(null);
  const [commentCount, setCommentCount] = useState(0);
  const [commentdata, setCommentData] = useState([]);
  const [errorMessage1, setErrorMessage1] = useState("");
  const [messageType1, setMessageType1] = useState("");
  const [isBox1Visible, setIsBox1Visible] = useState(false);
  const [dateInvited, setDateInvited] = useState("");
  const [colorCode, setColorCode] = useState("");
  const [firstTimeToContact, setFirstTimeToContact] = useState("");
  const [reassignCount, setReassignCount] = useState(0);
  const [reassignHistory, setReassignHistory] = useState([]);

  const [commentBoxOpen, setCommentBoxOpen] = React.useState(false);
  const handleCommentBoxClose = () => setCommentBoxOpen(false);
  const [addCommentLoader, setAddCommentLoader] = useState(false);

  const handleCommentBoxOpen = async (item) => {
    setCommentLoading(true);

    console.log("Get The userId :" + userid);
    console.log("Get The Commentid :" + item.id);
    setDateInvited(item.date_invited);
    setColorCode(item.color_code);
    setFirstTimeToContact(item.time_to_first_comment);
    setCommentFetchTextValue(item.name);
    setCommentFieldId(item.id);

    setCommentBoxOpen(true);

    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: item.id,
      },
    });

    //console.log(JSON.stringify(requestData));

    try {
      const response = await fetch(`${apiEndPoint}/get_comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
        setCommentLoading(false);
      }

      const data = await response.json();
      const decrypted = decryptData(data);

      console.log("A : " + JSON.stringify(decrypted));

      if (decrypted.status == "success") {
        setCommentLoading(false);
        console.log("Count:", decrypted.count);
        console.log("comments:", decrypted.data);
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        setCommentLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        console.log("Response data:", data);
      }
    } catch (error) {
      setCommentLoading(false);
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const addComment = async () => {
    const message = document.getElementById("txtComment").value;
    setAddCommentLoader(true);
    //setCommentLoading(true);
    const url = `${apiEndPoint}/create_comment`;
    const request = encryptData({
      data: {
        user_id: userid,
        investor_id: commentFieldId,
        comment: message,
      },
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: request,
      });

      const data = await response.json();
      const decrypted = decryptData(data);

      if (decrypted.status == "success") {
        setAddCommentLoader(false);

        document.getElementById("txtComment").value = "";
        // setCommentLoading(false);
        if (decrypted.count == 1) {
          setRefreshKey((prev) => prev + 1);
        }
        console.log("Count:", decrypted.count);
        console.log("comments:", decrypted.data);
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        setAddCommentLoader(false);
        document.getElementById("txtComment").value = "";
        //setCommentLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;
        console.log("Response data:", data);
      }
      //setResponse(result);
    } catch (error) {
      setAddCommentLoader(false);
      document.getElementById("txtComment").value = "";
      //setCommentLoading(false);
      console.error("Error:", error);
    }
  };

  // DELETE POPOVER
  const item = props.item;
  const onDelete = props.onDelete;
  const [open3, setOpen3] = useState(false);

  const handleConfirm = () => {
    onDelete(item.id); // delete logic from parent
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen3(false);
  };

  const renderSpeaker = (
    <Popover className="common__popover lead__popover" preventOverflow>
      <div className="tooltip_form_inner text-center">
        <div
          style={{
            fontSize: 18,
            color: "#141B3C",
            fontWeight: 500,
            lineHeight: 1.3,
          }}
        >
          Are you sure you want to delete this report ?
        </div>

        <div className="btn__group mt-5">
          <a href="#" className="btn__cancel" onClick={handleCancel}>
            Cancel
          </a>
          <a href="#" className="btn__assign" onClick={handleCancel}>
            Delete
          </a>
        </div>
      </div>
    </Popover>
  );

  const getTimeForTimezone = (timezone) => {
    if (!timezone) return "N/A";

    return new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(new Date());
  };

  // New component to show continuously updating time
  const LiveTimeCell = ({ timezone }) => {
    const [time, setTime] = useState(getTimeForTimezone(timezone));

    useEffect(() => {
      const interval = setInterval(() => {
        setTime(getTimeForTimezone(timezone));
      }, 1000); // update every second

      return () => clearInterval(interval); // cleanup
    }, [timezone]);

    return <td>{time}</td>;
  };

  const [uploadedfileList, setUploadedFileList] = useState([]);
  const [progress, setProgress] = useState({});
  const [timeRemaining, setTimeRemaining] = useState({});
  const [preview, setPreview] = useState("");
  const [reportType, setReportType] = useState("");

  const [showUploadManualModal, setUploadManualModal] = useState(false);
  const closeUploadManualModal = () => setUploadManualModal(false);

  const [showUploadpreviewModal, setUploadpreviewModal] = useState(false);
  const closeUploadpreviewModal = () => setUploadpreviewModal(false);

  const handleRemove = async (file) => {
    console.log("Removed file:", file);

    const url = `${apiEndPoint}/delete_investor_file`;

    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: selectedFileInvestorId,
      },
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      const result = await response.json();
      const data = decryptData(result);
      console.log("API Response:", data);

      if (data?.status === true) {
        console.log("File deleted successfully:", file.fileKey);

        // const newFiles = data.data.files.map((file) => ({
        //   id : file.id,
        //   name: file.title,
        //   fileKey: file.id,
        //   url: file.file_url,
        //   type : file.file_type,
        //   size : file.file_size,
        // }));
        setUploadedFileList([]);
      } else {
        console.error(
          "Failed to delete file:",
          data?.status || "Unknown error"
        );
      }

      // Agar API success response de to file list se remove karne ka logic yahan likho
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const handleUploadClick = async (item) => {
    setUploadedFileList([]);
    setSelectedFileInvestorId(item.id);
    try {
      const response = await fetch(`${apiEndPoint}/get_investor_file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData({
          data: {
            investor_id: item.id,
            user_id: userid,
          },
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      const data = decryptData(result);
      const responseData = data?.data?.data;

      if (
        data?.data?.status === "success" &&
        ((Array.isArray(responseData) && responseData.length > 0) ||
          (!Array.isArray(responseData) && responseData))
      ) {
        const filesArray = Array.isArray(responseData)
          ? responseData
          : [responseData];

        const newFiles = filesArray.map((file) => ({
          id: file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type: file.file_type,
          size: file.file_size,
        }));

        setUploadedFileList(newFiles);
      }

      // if (data.data.status == "success" && data?.data?.data) {
      //   const filesArray = Array.isArray(data.data.data) ? data.data.data : [data.data.data];

      //   const newFiles = filesArray.map((file) => ({
      //     id : file.id,
      //     name: file.title,
      //     fileKey: file.id,
      //     url: file.file_url,
      //     type : file.file_type,
      //     size : file.file_size,
      //   }));

      //  // setUploadedFileList((prev) => [...prev, ...newFiles]);

      //  console.log(newFiles);
      //  setUploadedFileList(newFiles);

      // }

      setUploadManualModal(true);
      //setFiles(result.data); // API response ke `data` ko store kar rahe hain
      //  console.log("Files:", data);
    } catch (error) {
      console.error("Error fetching task files:", error.message);
    }
  };

  const handlePreviewClick = (file) => {
    console.log(file);
    setReportType(file.type);
    setPreview(file.url);
    setUploadpreviewModal(true);
  };

  // Function to handle file selection and upload
  const handleFileSelect = async (file) => {
    // if(uploadedfileList.length > 0 )
    // {
    //   toastIdRef.current = toast({ description: "A file already exists. Please delete the existing file before uploading a new one.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
    //   return false;
    // }

    if (!file || !file.blobFile) return;

    const newFile = {
      file: file.blobFile,
      name: file.name,
      url: URL.createObjectURL(file.blobFile),
      startTime: Date.now(),
      progress: 0,
      status: "Uploading...", // Initial status
    };

    setUploadedFileList((prevFiles) => [...prevFiles, newFile]); // Append new file to list
    await uploadFile(newFile);
  };

  // Function to upload files to the API
  const uploadFile = async (fileObj) => {
    setProgress((prev) => ({ ...prev, [fileObj.name]: 0 }));

    const requestData = encryptData({
      data: {
        investor_id: selectedFileInvestorId,
        user_id: userid,
        title: fileObj.name,
      },
    });

    const formData = new FormData();
    formData.append("data", requestData);
    formData.append("files", fileObj.file);

    let progressValue = 0;
    const startTime = Date.now();

    // Fake progress update every 500ms
    const interval = setInterval(() => {
      progressValue += Math.random() * 10; // Random increment
      progressValue = Math.min(progressValue, 95); // Max 95% tak jayega

      setProgress((prev) => ({
        ...prev,
        [fileObj.name]: Math.round(progressValue),
      }));
    }, 500);

    try {
      const response = await fetch(`${apiEndPoint}/upload_investor_files`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      console.log(`Upload Success: ${fileObj.name}`, result);
      const data = decryptData(result);
      console.log(data);

      if (data.data?.status === "success" && data?.data?.files?.length > 0) {
        const newFiles = data?.data?.files.map((file) => ({
          id: file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type: file.file_type,
          size: file.file_size,
        }));
        setUploadedFileList(newFiles);
      } else if (data?.status === "error") {
        setUploadedFileList([]);

        toastIdRef.current = toast({
          description: data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;

        // setErrorMessage(result?.data?.message);
        // setMessageType('error');
      }

      // Once upload completes, set progress to 100%
      setProgress((prev) => ({ ...prev, [fileObj.name]: 100 }));
    } catch (error) {
      console.error(`Upload Failed: ${fileObj.name}`, error);
    } finally {
      clearInterval(interval); // Stop progress updates
    }
  };

  const getFileIcon = (fileType) => {
    if (fileType.includes("jpeg") || fileType.includes("jpg")) return iconJPG;
    if (fileType.includes("png")) return iconPNG;
    if (fileType.includes("pdf")) return iconPDF;
    return null;
  };

  const priorityClassMap = {
    Medium: "table_icon_medium",
    Low: "table_icon_low",
    "Very Low": "table_icon_very_low",
    High: "table_icon_high",
    "Very High": "table_icon_very_high",
  };

  const [userActivityOpen, setUserActivityOpen] = React.useState(false);
  const handleUserActivityClose = () => setUserActivityOpen(false);
  const [activityData, setActivityData] = useState([]);

  const [LogActiveitiCallModalOpen, setLogActiveitiCallModalOpen] =
    useState(false);
  const [assignStatus, setAssignStatus] = useState(null);

  const statusOptions = [
    { label: "Completed", value: "completed" },
    { label: "Waiting for Reply", value: "waiting" },
    { label: "Call Back Needed", value: "callback" },
    { label: "No Answer", value: "noanswer" },
  ];

  // const handleEditModalClose = () => {
  //     setLogActiveitiCallModalOpen(false);
  // };

  const statusOptionsData = [
    { label: "Completed", value: "completed", color: "#1FB16E" },
    { label: "Waiting for Reply", value: "waiting", color: "#FF9012" },
    { label: "Call Back Needed", value: "callback", color: "blue" },
    { label: "No Answer", value: "noanswer", color: "#D80027" },
  ];

  // Tabs
  const [activeTab, setActiveTab] = useState("log");

  // HISTORY TAB
  const [show, setShow] = useState(false);
  const [expandedMonths, setExpandedMonths] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleMonth = (month) => {
    setExpandedMonths((prev) =>
      prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
    );
  };

  const toggleItem = (month, index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [month]: {
        ...prev[month],
        [index]: !prev[month]?.[index],
      },
    }));
  };

  const [historyData, setHistoryData] = useState({});

  const [reason, setReason] = useState("");
  const [interactionSummary, setInteractionSummary] = useState("");
  const [investmentInterestAmount, setInvestmentInterestAmount] = useState("");
  const [followUpPlan, setFollowUpPlan] = useState("");
  const [followUpDate, setFollowUpDate] = useState(null);

  const handleInvestmentChange = (e) => {
    setInvestmentInterestAmount(e.target.value);
  };

  const handleFollowUpChange = (e) => {
    setFollowUpPlan(e.target.value);
  };

  const handleUserActivity = async (item) => {
    // Reset all states
    setSelectedFileInvestorId(item.id);
    setUserActivityOpen(true);
    setActivityData(null);
    setElapsed("");
    setTotalMinutes(0);
    setColorClass("dark__green__text");
    setDotClass("green__dot");
    setHistoryData({}); // Initialize with empty object

    setExpandedMonths([]);
    setExpandedItems({});

    // Reset form fields
    setReason(""); // Reason for delay textarea
    setCallTypeId(null); // Call Type select
    setCallStatusId(null); // Status select
    setInteractionSummary(""); // Interaction Summary textarea
    setSelectedOutcome(null); // Outcome select
    setSelectedPriority(null); // Priority Level select
    setInvestmentInterestAmount(""); // Updated Investment Interest Amount input
    setFollowUpPlan(""); // Follow-Up Plan input
    setFollowUpDate(null); // Follow-Up Date picker

    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: item.id,
      },
    });

    try {
      // First API call - get communication detail
      const response = await fetch(`${apiEndPoint}/get_communication_detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error(
          `Network response was not ok: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      const decrypted = decryptData(data);

      if (decrypted.status !== "success") {
        throw new Error(
          decrypted.message || "Failed to fetch communication details"
        );
      }

      // Update state with communication details
      setAssignUserid(decrypted.data.current_user_assigned_id);
      setReason(decrypted.data.reason_for_delay);
      setActivityData(decrypted.data);

      // Set color based on response time
      const total = decrypted.data.time_to_first_contact_min || 0;
      if (total >= 10) {
        setColorClass("dark__red__text");
        setDotClass("red__dot");
      } else if (total >= 5) {
        setColorClass("dark__orange__text");
        setDotClass("orange__dot");
      }

      // Second API call - get communication history
      const historyResponse = await fetch(
        `${apiEndPoint}/get_communication_history`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestData,
        }
      );

      if (!historyResponse.ok) {
        throw new Error(`History request failed: ${historyResponse.status}`);
      }

      const historyJson = await historyResponse.json();
      const decryptedHistory = decryptData(historyJson);

      // FIX: Properly access nested data structure
      const historyData = decryptedHistory.data || decryptedHistory;

      if (!historyData) {
        throw new Error("History data is empty");
      }

      if (historyData.status !== "success") {
        throw new Error(
          historyData.message || "History API returned non-success status"
        );
      }

      // Process history data
      const processedHistory = mapHistoryData(historyData);
      setHistoryData(processedHistory);
    } catch (error) {
      console.error("Activity fetch error:", {
        message: error.message,
        stack: error.stack,
      });

      toast({
        title: "Error",
        description: error.message.includes("network")
          ? "Network error - please check your connection"
          : "Failed to load activity data",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "bottom",
      });

      setHistoryData({});
    }
  };

  // This mapper keeps your original HTML structure intact
  const mapHistoryData = (apiData) => {
    const result = {};

    // Process follow-ups
    if (Array.isArray(apiData.follow_up)) {
      result["Upcoming & Overdue"] = apiData.follow_up.map((item) => ({
        type: item.mode ? capitalizeFirstLetter(item.mode) : "Follow-up",
        time: item.follow_up_date ? formatDate(item.follow_up_date) : "No date",
        details: item.follow_up_note
          ? {
              input: true,
              note: item.follow_up_note,
            }
          : null,
        rawData: item, // Preserve original data
      }));
    }

    // Process history entries
    if (apiData.history && typeof apiData.history === "object") {
      Object.entries(apiData.history).forEach(([monthKey, entries]) => {
        if (Array.isArray(entries)) {
          const formattedMonth = formatMonthKey(monthKey);
          result[formattedMonth] = entries.map((entry) => ({
            type: entry.mode ? capitalizeFirstLetter(entry.mode) : "Activity",
            time: formatDateTime(entry.created_at),
            details: {
              input: true,
              summary: entry.summary,
              outcome: entry.outcome,
            },
            rawData: entry, // CRUCIAL - preserves original timestamps
          }));
        }
      });
    }

    return result;
  };

  // Keep all your original helper functions exactly as they were:
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  // Keep your existing helper functions but ensure they're correct:
  const formatDateTime = (dateTimeString) => {
    try {
      const date = new Date(dateTimeString);
      if (isNaN(date.getTime())) return "Invalid date";
      return date.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      console.error("Date formatting error:", error);
      return "Invalid date";
    }
  };

  const formatMonthKey = (monthKey) => {
    try {
      const [month, year] = monthKey.split("_");
      const fullYear = year.length === 2 ? `20${year}` : year;
      return `${month} • ${fullYear}`;
    } catch (error) {
      console.error("Month key formatting error:", error);
      return monthKey;
    }
  };

  // User Activity
  const [isReasonActive, setIsReasonActive] = useState(false);

  const handleReasonClick = () => {
    setIsReasonActive(true); // or toggle with !isReasonActive if you want toggle behavior
  };

  // Timer State
  const [elapsed, setElapsed] = useState("");
  const [colorClass, setColorClass] = useState("dark__green__text");
  const [dotClass, setDotClass] = useState("green__dot");
  const [totalMinutes, setTotalMinutes] = useState(0);

  // Utility to get current moment in specific timezone
  const getMomentForTimezone = (timezone) => {
    return moment.tz(timezone); // moment object
  };

  useEffect(() => {
    if (!activityData?.invited_at || !activityData?.time_zone) return;

    // If locked, use stored values
    if (activityData?.is_locked === 1) {
      setElapsed(activityData?.time_to_first_contact || "");
      const lockedMinutes = parseInt(
        activityData?.time_to_first_contact_min || "0",
        10
      );
      setTotalMinutes(lockedMinutes);
      updateColorClasses(lockedMinutes);
      return;
    }

    // Parse the invited time in the investor's timezone
    const invitedAt = moment.tz(
      activityData.invited_at.trim(),
      "DD MMM YYYY hh:mm:ss A",
      activityData.time_zone
    );

    if (!invitedAt.isValid()) {
      console.error("Invalid invited_at date:", activityData.invited_at);
      setElapsed("Invalid date");
      return;
    }

    const interval = setInterval(() => {
      // Get current time in investor's timezone
      const currentTimeInInvestorTz = moment.tz(activityData.time_zone);

      // Calculate difference in milliseconds
      const diffMs = currentTimeInInvestorTz.diff(invitedAt);

      // If invited time is in the future, show 0s
      if (diffMs < 0) {
        setElapsed("0s");
        setTotalMinutes(0);
        updateColorClasses(0);
        return;
      }

      // Calculate time components
      const totalSeconds = Math.floor(diffMs / 1000);
      const totalMinutesCalc = Math.floor(diffMs / (1000 * 60));

      const years = Math.floor(totalSeconds / (365 * 24 * 60 * 60));
      const months = Math.floor(
        (totalSeconds % (365 * 24 * 60 * 60)) / (30 * 24 * 60 * 60)
      );
      const days = Math.floor(
        (totalSeconds % (30 * 24 * 60 * 60)) / (24 * 60 * 60)
      );
      const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;

      // Format time string based on duration
      let timeString = "";

      if (years > 0) {
        timeString = `${years}y ${months}mo ${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (months > 0) {
        timeString = `${months}mo ${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (days > 0) {
        timeString = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (hours > 0) {
        timeString = `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        timeString = `${minutes}m ${seconds}s`;
      } else {
        timeString = `${seconds}s`;
      }

      setElapsed(timeString);
      setTotalMinutes(totalMinutesCalc);
      updateColorClasses(totalMinutesCalc);
    }, 1000);

    return () => clearInterval(interval);
  }, [
    activityData?.invited_at,
    activityData?.time_zone,
    activityData?.is_locked,
  ]);

  const updateColorClasses = (minutes) => {
    if (minutes >= 10) {
      setColorClass("dark__red__text");
      setDotClass("red__dot");
    } else if (minutes >= 5) {
      setColorClass("dark__orange__text");
      setDotClass("orange__dot");
    } else {
      setColorClass("dark__green__text");
      setDotClass("green__dot");
    }
  };

  const [callTypeOptions, setCallTypeOptions] = useState([]);
  const [callStatusOptions, setCallStatusOptions] = useState([]);
  const [callTypeId, setCallTypeId] = useState();
  const [callStatusId, setCallStatusId] = useState();

  useEffect(() => {
    const fetchCallTypes = async () => {
      try {
        const response = await fetch(`${apiEndPoint}/get_call_types`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: encryptData({
            data: {
              user_id: userid,
            },
          }),
        });

        const result = await response.json();
        const decrypted = decryptData(result);

        if (decrypted.data?.status === "success") {
          // Map the API data to the format expected by SelectPicker
          const formattedOptions = decrypted.data.data.map((item) => ({
            label: item.label,
            value: item.value,
            // Assign colors based on status value
          }));

          console.log("Formatted options:", formattedOptions);
          setCallTypeOptions(formattedOptions);
        }
      } catch (err) {
        console.error("Failed to fetch call statuses:", err);
      }
    };

    fetchCallTypes();
  }, []);

  useEffect(() => {
    const fetchCallStatuses = async () => {
      try {
        const response = await fetch(`${apiEndPoint}/get_call_status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: encryptData({
            data: {
              user_id: userid,
            },
          }),
        });

        const result = await response.json();
        const decrypted = decryptData(result);

        if (decrypted.data?.status === "success") {
          // Map the API data to the format expected by SelectPicker
          const formattedOptions = decrypted.data.data.map((item) => ({
            label: item.label,
            value: item.value,
            // Assign colors based on status value
            color: getStatusColor(item.value),
          }));

          console.log("Formatted options:", formattedOptions);
          setCallStatusOptions(formattedOptions);
        }
      } catch (err) {
        console.error("Failed to fetch call statuses:", err);
      }
    };

    fetchCallStatuses();
  }, []);

  const getStatusColor = (statusValue) => {
    switch (statusValue) {
      case "connected":
        return "#4CAF50"; // green
      case "not_connected":
        return "#F44336"; // red
      case "busy":
        return "#FFC107"; // yellow
      case "switched_off":
        return "#9E9E9E"; // gray
      case "network_issue":
        return "#FF9800"; // orange
      case "call_dropped":
        return "#fd9595"; // pink-red
      case "invalid_number":
        return "#8B0000"; // dark red
      default:
        return "#1FB16E"; // default green
    }
  };

  const [saveLoading, setSaveLoading] = useState(false);

  const handleSaveLogActivity = async () => {
    setSaveLoading(true);

    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: selectedFileInvestorId,
        mode: "call",
        reason_for_delay: reason,
        call_type: callTypeId,
        call_status: callStatusId,
        summary: interactionSummary,
        outcome: selectedOutcome,
        priority: selectedPriority,
        updated_investment_amount: investmentInterestAmount,
        follow_up_date: followUpDate,
        follow_up_plan: followUpPlan,
      },
    });
    console.log("Data is :", requestData);

    try {
      const response = await fetch(
        `${apiEndPoint}/update_communication_detail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestData,
        }
      );

      if (!response.ok) {
        setSaveLoading(false);
        throw new Error("Network response was not ok " + response.statusText);
      }

      const data = await response.json();
      const decrypted = decryptData(data);
      if (decrypted.data.status == "success") {
        toastIdRef.current = toast({
          description: decrypted.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setSaveLoading(false);
        setUserActivityOpen(false);
      } else {
        setSaveLoading(false);
      }
    } catch (error) {
      setSaveLoading(false);
      console.error("Fetch error:", error.message);
    }
  };

  const handleCallTypeChange = (selectedOption) => {
    setCallTypeId(selectedOption); // Update selectedPeriod state with the selected option
  };

  const handleCallStatusChange = (selectedOption) => {
    setCallStatusId(selectedOption); // Update selectedPeriod state with the selected option
  };

  const [priorityOptions, setPriorityOptions] = useState([]);
  const [outcomeOptions, setOutcomeOptions] = useState([]);

  const [selectedPriority, setSelectedPriority] = useState();
  const [selectedOutcome, setSelectedOutcome] = useState();

  useEffect(() => {
    const fetchPriorityOptions = async () => {
      const url = `${apiEndPoint}/get_priorities`;
      const payload = encryptData({
        data: { user_id: userid },
      });

      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
        });

        const result = await res.json();
        const decrypted = decryptData(result);
        console.log("Priority API decrypted response:", decrypted);

        const options = decrypted.data.data.map((item) => ({
          label: item.name || item.label,
          value: item.id || item.value,
        }));

        console.log("Formatted Priority options:", options);
        setPriorityOptions(options);
      } catch (err) {
        console.error("Error fetching priorities:", err);
      }
    };

    const fetchOutcomeOptions = async () => {
      const url = `${apiEndPoint}/get_outcomes`;
      const payload = encryptData({
        data: { user_id: userid },
      });

      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
        });

        const result = await res.json();
        const decrypted = decryptData(result);
        console.log("Outcome API decrypted response:", decrypted);

        const options = decrypted.data.data.map((item) => ({
          label: item.name || item.label,
          value: item.id || item.value,
        }));

        console.log("Formatted Outcome options:", options);
        setOutcomeOptions(options);
      } catch (err) {
        console.error("Error fetching outcomes:", err);
      }
    };

    fetchPriorityOptions();
    fetchOutcomeOptions();
  }, []);

  const handleSaveFollowUp = async (entry, idx) => {
    const note = entry.userNote ?? entry.rawData.follow_up_note ?? "";
    const followUpId = entry.rawData?.follow_up_id || entry.rawData?.id;
    const investorId = entry.rawData?.dealmaker_investor_id;
    const isCompleted =
      entry.userChecked ?? entry.rawData?.is_completed ?? false;

    const payload = encryptData({
      data: {
        user_id: userid,
        investor_id: investorId,
        follow_up_id: parseInt(followUpId, 10),
        is_completed: String(isCompleted),
        follow_up_note: note,
      },
    });

    try {
      const response = await fetch(`${apiEndPoint}/update_follow_up_detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      });

      const data = await response.json();
      const decrypted = decryptData(data);
      if (decrypted.data.status == "success") {
        toastIdRef.current = toast({
          description: decrypted.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setSaveLoading(false);
        setUserActivityOpen(false);
      } else {
        setSaveLoading(false);
      }

      // Update local state
      const updated = [...historyData["Upcoming & Overdue"]];
      updated[idx].rawData.is_completed = isCompleted;
      updated[idx].rawData.follow_up_note = note;
      updated[idx].userChecked = undefined;
      updated[idx].userNote = undefined;
      setHistoryData({ ...historyData, "Upcoming & Overdue": updated });
    } catch (error) {}
  };

  const modalBodyRef = useRef(null);


  useEffect(() => {
    if (modalBodyRef.current && activeTab === "history") {
      modalBodyRef.current.scrollTop = 0;
    }
  }, [activeTab]);


  return (
    <>
      <Sidebar />
      <ChakraProvider resetCSS={false}>
        <Wrap></Wrap>
      </ChakraProvider>

      <div id="header">
        {renderMessage()}
        <div className="logo">
          <div className="logo_icon">
            <img src={Logo} />
          </div>
          <div className="brand_name">Dealmaker Leads</div>
        </div>

        <div className="header_table_filter LeadFilter">
          <div className="searchfield">
            <button className="btn_search">
              <i className="icon-search2"></i>
            </button>
            <input
              type="text"
              className="filter_searchfield"
              placeholder="Search"
              onChange={handleSearch}
              value={searchInput}
            />
          </div>

          <div className="dropdown_style filter_by_country">
            <SelectPicker
              data={countryData}
              searchable={true}
              // style={{ width: 150 }}
              placeholder="Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={FundedStatusData}
              searchable={false}
              // style={{ width: 130 }}
              placeholder="Funding Status"
              onChange={handleStatusChange}
              value={statusId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={subscriptionData}
              searchable={false}
              // style={{ width: 120 }}
              placeholder="Subscription"
              onChange={handleSubscription}
              value={subscriptionId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={progressStatus}
              searchable={false}
              // style={{ width: 140 }}
              placeholder="State"
              onChange={handleProgressStatus}
              value={progressId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={ScoreStatus}
              searchable={false}
              // style={{ width: 80 }}
              placeholder="Score"
              onChange={handleScoreStatus}
              value={scoreId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={UTMSourceData}
              searchable={false}
              // style={{ width: 160 }}
              placeholder="Source"
              onChange={handleUTMSource}
              value={UTMSourceId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <DatePicker
              oneTap
              style={{ width: 140 }}
              placeholder="Choose Date"
              format="dd-MM-yyyy"
              value={filterDate}
              onChange={handleFilterDateChange}
            />
          </div>

          {/* <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="All Compliance statuses"
                    />
            </div>
            <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="Both Publish Statuses"
                    />
            </div> */}

          <a
            href="javascript:void(0)"
            className="btn_clear_filter"
            style={{ textDecoration: "none", width: "auto" }}
            onClick={handleClearFilters}
          >
            Clear
          </a>
        </div>
      </div>
      <div className="container-fluid content pb-5">
        <div
          className="company_table_list"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          {globalLoading && (
            <Placeholder.Grid
              rows={20}
              columns={9}
              active
              style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
            />
          )}

          {/* Table */}
          {!globalLoading && (
            <>
              <div
                className="table-responsive clsPagingWrap"
                style={{ maxHeight: "80vh" }}
              >
                <table className="table  table__iri__sticky table__lead__sticky">
                  <thead>
                    <tr>
                      {columnOrder.map((col) => {
                        // Change all comparisons from col === "Column Name" to col.name === "Column Name"
                        if (col.name === "Action") {
                          return (
                            <th
                              className="sticky-col left-col-1 waitlist_id_col"
                              style={{ textAlign: "center" }}
                            >
                              Actions
                            </th>
                          );
                        }
                        if (col.name === "Lead ID") {
                          return (
                            <th
                              className="sticky-col left-col-2"
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>Lead ID</span>{" "}
                                <Button className="btn__refresh_header">
                                  <img
                                    src={IconRefresh}
                                    onClick={fetchGlobalReport}
                                  />
                                </Button>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Full Name") {
                          return (
                            <th
                              className="sticky-col left-col-3"
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 12,
                                }}
                              >
                                <span>Name</span>
                                <Button
                                  className="btn__cell_show"
                                  onClick={handleOpenDrawer}
                                >
                                  <img src={IconEye} />
                                </Button>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Email Address") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Email</span>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Phone Number") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Phone</span>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Country") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Country</Tooltip>}
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Country
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Local Time") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Local Time
                            </th>
                          );
                        }
                        if (col.name === "Likehood Score") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Investment Likehood Score</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Score</span>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Date Invited") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              onClick={() => handleIconClick("created_at")}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Date Invited{" "}
                              <img
                                src={isAscending ? icon_Asc : icon_Desc}
                                style={{ height: 16, marginLeft: 10 }}
                                alt={
                                  isAscending
                                    ? "Ascending Icon"
                                    : "Descending Icon"
                                }
                              ></img>
                            </th>
                          );
                        }
                        if (col.name === "Time to First Contact") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              onClick={() => handleIconClick("created_at")}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Time to First Contact
                            </th>
                          );
                        }
                        if (col.name === "Investment Amount") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              onClick={() =>
                                handleIconClick("investment_amount")
                              }
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Amount{" "}
                              <img
                                src={isAscending2 ? icon2_Asc : icon2_Desc}
                                style={{ height: 16, marginLeft: 10 }}
                                alt={
                                  isAscending2
                                    ? "Ascending Icon"
                                    : "Descending Icon"
                                }
                              ></img>
                            </th>
                          );
                        }
                        if (col.name === "Assigned User") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Assigned User
                            </th>
                          );
                        }
                        if (col.name === "IR Notes") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              IR Notes
                            </th>
                          );
                        }
                        if (col.name === "Source") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Source
                            </th>
                          );
                        }
                        if (col.name === "Status") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Estimated Investment Timeline</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Dealmaker Status
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Progress State") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Investor Progress State</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Progress State
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Check Status") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Background Check Status</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Background Check
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Payment") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Payment
                            </th>
                          );
                        }
                        if (col.name === "Web User") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>App/Web User</Tooltip>}
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                App/Web users
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Plateform Usage") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Plateform Usage</span>
                                <Whisper
                                  placement="top"
                                  controlId="control-id-hover"
                                  trigger="hover"
                                  speaker={
                                    <Tooltip>The data not found</Tooltip>
                                  }
                                >
                                  <span className="cls_red_dot"></span>
                                </Whisper>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Time of Invite") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  Subscription Tier at Time of Invite
                                </Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Subscription
                              </th>
                            </Whisper>
                          );
                        }

                        if (col.name === "Time Since Subscription") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Time Since Subscription
                            </th>
                          );
                        }
                        if (col.name === "Share Price") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Share Price</span>
                                <Whisper
                                  placement="top"
                                  controlId="control-id-hover"
                                  trigger="hover"
                                  speaker={
                                    <Tooltip>The data not found</Tooltip>
                                  }
                                >
                                  <span className="cls_red_dot"></span>
                                </Whisper>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Shares") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Initial shares</span>
                              </div>
                            </th>
                          );
                        }

                        if (col.name === "Time Based Bonus") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Time Based Bonus
                            </th>
                          );
                        }
                        if (col.name === "Amount Based Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Amount Based Bonus</Tooltip>}
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Amount Based Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Existing Investor Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Existing Investor Bonus</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Inv. Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Premium Subscription Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Premium Subscription Bonus</Tooltip>
                              }
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                P. Sub. Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Total Bonus") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Total Bonus
                            </th>
                          );
                        }
                        if (col.name === "Accredited") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Accredited Status</Tooltip>}
                              key={col.name}
                              data-column-id={col.name}
                            >
                              <th
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Accredited</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Notes") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Notes
                            </th>
                          );
                        }
                        if (col.name === "Address") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Address
                            </th>
                          );
                        }

                        if (col.name === "UTM Source") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              UTM Source
                            </th>
                          );
                        }
                        if (col.name === "UTM Medium") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              UTM Medium
                            </th>
                          );
                        }
                        if (col.name === "UTM Campaign") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              UTM Campaign
                            </th>
                          );
                        }
                        if (col.name === "Certificate") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Certificate Upload</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col.name ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col.name
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Certificate
                              </th>
                            </Whisper>
                          );
                        }

                        return null;
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {reportdata && reportdata.length === 0 ? (
                      <tr>
                        <td
                          colSpan="14"
                          style={{
                            textAlign: "center",
                            fontSize: 20,
                            paddingTop: 60,
                            paddingBottom: 30,
                          }}
                        >
                          No data available
                        </td>
                      </tr>
                    ) : (
                      reportdata &&
                      reportdata.map((item, index) => (
                        <>
                          <tr
                            style={{ cursor: "pointer" }}
                            className={
                              index % 2 === 0
                                ? "accordion-toggle collapsed table_tr_odd"
                                : " accordion-toggle collapsed table_tr_even"
                            }
                          >
                            {columnOrder.map((col) => {
                              if (col.name === "Action")
                                return (
                                  <td style={{ textAlign: "center" }}>
                                    <button
                                      className="btn_edit_icon"
                                      onClick={() => handleEditModalOpen(item)}
                                    >
                                      <i className="icon-edit"></i>
                                    </button>
                                  </td>
                                );
                              if (col.name === "Lead ID")
                                return <td key={col.name}>LD-{item.id}</td>;
                              if (col.name === "Full Name")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    onClick={() => handleRowClick(index)}
                                  >
                                    <div className="name__col_cell2">
                                      <span>{item.name}</span>
                                      {item.more_invesment_count > 0 && (
                                        <Whisper
                                          placement="top"
                                          controlId="control-id-hover"
                                          trigger="hover"
                                          speaker={
                                            <Tooltip>
                                              Number Of Investments
                                            </Tooltip>
                                          }
                                        >
                                          <span className="entry_number">
                                            {item.more_invesment_count}
                                          </span>
                                        </Whisper>
                                      )}
                                    </div>
                                  </td>
                                );
                              if (col.name === "Email Address")
                                return (
                                  <td key={col.name} data-column-id={col.name}>
                                    {item.email}
                                  </td>
                                );

                              if (col.name === "Phone Number")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    {formatPhoneNumberGlobal(item.phone)}
                                  </td>
                                ); //formatPhoneNumberGlobal(item.phone)

                              if (col.name === "Country")
                                return (
                                  <td
                                    key={col.name}
                                    style={{}}
                                    data-column-id={col.name}
                                  >
                                    <div className="company_name_td">
                                      {item.country ? (
                                        <>
                                          <div className="clogo">
                                            <CircleFlag
                                              countryCode={item.countryCode?.toLowerCase()}
                                              style={{ width: 30, height: 30 }}
                                            />
                                          </div>
                                          {item.country}
                                        </>
                                      ) : (
                                        <div className="clogo">-</div>
                                      )}
                                    </div>
                                  </td>
                                );
                              if (col.name === "Local Time")
                                return (
                                  <td key={col.name} data-column-id={col.name}>
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>{item.time_zone}</Tooltip>
                                      }
                                    >
                                      <span>
                                        <LiveTimeCell
                                          timezone={item.time_zone}
                                        />
                                      </span>
                                    </Whisper>
                                  </td>
                                );
                              if (col.name === "Likehood Score")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.likelihood_score ? (
                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip>{item.priority}</Tooltip>
                                        }
                                      >
                                        <div className="table_title_icon">
                                          {" "}
                                          <span
                                            className={
                                              priorityClassMap[item.priority] ||
                                              ""
                                            }
                                          >
                                            {item.likelihood_score}
                                          </span>{" "}
                                        </div>
                                      </Whisper>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </td>
                                );
                              if (col.name === "Date Invited")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.date_invited || "-"}
                                  </td>
                                );
                              if (col.name === "Time to First Contact")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    <h6
                                      style={{
                                        fontSize: 13,
                                        color: "#666",
                                        textAlign: "left",
                                      }}
                                    >
                                      {" "}
                                      <span
                                        className={`time_fcontact_circle ${
                                          item.color_code === "green"
                                            ? "time_fcontact_circle_green"
                                            : item.color_code === "yellow"
                                            ? "time_fcontact_circle_yellow"
                                            : item.color_code === "orange"
                                            ? "time_fcontact_circle_orange"
                                            : item.color_code === "red"
                                            ? "time_fcontact_circle_red"
                                            : ""
                                        }`}
                                      ></span>
                                      <span>
                                        {item.time_to_first_comment || "-"}
                                      </span>
                                    </h6>
                                  </td>
                                );
                              if (col.name === "Investment Amount")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.investment_amount || "-"}
                                  </td>
                                );
                              if (col.name === "Assigned User")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    {item.reassign_msg?.length > 0 ? (
                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip>{item.reassign_msg}</Tooltip>
                                        }
                                      >
                                        <div
                                          style={{ cursor: "pointer" }}
                                          className="name__col_cell"
                                        >
                                          {" "}
                                          <div className="img_name_profile">
                                            {" "}
                                            <img
                                              src={item.user_profile_img}
                                              alt="User"
                                            />{" "}
                                          </div>{" "}
                                          <span>{item.user_in_charge}</span>{" "}
                                        </div>
                                      </Whisper>
                                    ) : (
                                      <div className="name__col_cell">
                                        {" "}
                                        <div className="img_name_profile">
                                          {" "}
                                          <img
                                            src={item.user_profile_img}
                                          />{" "}
                                        </div>{" "}
                                        <span> {item.user_in_charge} </span>{" "}
                                      </div>
                                    )}
                                  </td>
                                );
                              if (col.name === "IR Notes")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <Button
                                      className="btn__comment__notes"
                                      data-comment={`${item.id}`}
                                      //onClick={() => handleCommentBoxOpen(item)} //OLD IR Notes
                                      onClick={() => handleUserActivity(item)}
                                    >
                                      <img src={iconNotes} />
                                    </Button>
                                  </td>
                                );
                              if (col.name === "Source")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.source || "-"}
                                  </td>
                                );

                              if (col.name === "Status")
                                return (
                                  <td
                                    key={col.name}
                                    style={{}}
                                    data-column-id={col.name}
                                  >
                                    <span
                                      className={`lead__status ${
                                        {
                                          Offline: "lead__status_offline",
                                          Online: "lead__status_online",
                                          signed: "lead__status_signed",
                                          "Waiting for Countersignature":
                                            "lead__status_waiting_countersignature",
                                          invited: "lead__status_invited",
                                          Accepted: "lead__status_accepted",
                                          inactive: "lead__status_inactive",
                                          "Questionnaire in Progress":
                                            "lead__status_questionnaire",
                                        }[item.status] || ""
                                      }`}
                                    >
                                      {item.status || "-"}
                                    </span>
                                  </td>
                                );
                              if (col.name === "Progress State")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <span className="lead__progress__state">
                                      {item.investor_progress_state || "-"}
                                    </span>
                                  </td>
                                );
                              if (col.name === "Check Status")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <span
                                      className={`tag_td ${
                                        {
                                          Passed: "halal_tag",
                                          Pending: "doughtful_tag",
                                          Flagged: "not_halal_tag",
                                        }[item.background_check] || ""
                                      }`}
                                      style={{ maxWidth: 110 }}
                                    >
                                      {item.background_check || "-"}
                                    </span>
                                  </td>
                                );
                              if (col.name === "Payment")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.payment || "-"}
                                  </td>
                                );
                              if (col.name === "Web User")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.user_platform || "-"}
                                  </td>
                                );
                              if (col.name === "Plateform Usage")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.platform_usage || "-"}
                                  </td>
                                );
                              if (col.name === "Time of Invite")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span
                                      className={` ${
                                        {
                                          PREMIUM: "tier__tag tier_premium",
                                          FREEMIUM: "tier__tag tier_freemium",
                                          STARTER: "tier__tag tier_starter",
                                          PREMIUM_PLUS:
                                            "tier__tag tier_premium_plus",
                                          "Not a user":
                                            "tier__tag tier_not_user",
                                        }[item.subscription] || ""
                                      }`}
                                    >
                                      {item.subscription || "-"}
                                    </span>
                                  </td>
                                );
                              if (col.name === "Share Price")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.share_price || "-"}
                                  </td>
                                );
                              if (col.name === "Shares")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.share || "-"}
                                  </td>
                                );

                              if (col.name === "Time Based Bonus")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.time_based_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Amount Based Bonus")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.amount_based_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Existing Investor Bonus")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.existing_investor_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Premium Subscription Bonus")
                                return (
                                  <td
                                    style={{
                                      fontWeight: 600,
                                      textAlign: "center",
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.premium_subscription_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Total Bonus")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.total_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Accredited")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span>{item.accredited || "-"}</span>
                                  </td>
                                );
                              if (col.name === "Notes")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={<Tooltip>{item.notes}</Tooltip>}
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {notes__truncate(item.notes)}
                                      </span>
                                    </Whisper>
                                  </td>
                                );
                              if (col.name === "Address")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>{item.address}</Tooltip>
                                      }
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {address__truncate(item.address)}
                                      </span>
                                    </Whisper>
                                  </td>
                                );

                              if (col.name === "Time Since Subscription")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.subscriptionDuration ? (
                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip>
                                            {item.subscription_date}
                                          </Tooltip>
                                        }
                                      >
                                        <span>{item.subscriptionDuration}</span>
                                      </Whisper>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </td>
                                );
                              if (col.name === "UTM Source")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_source || "-"}
                                  </td>
                                );
                              if (col.name === "UTM Medium")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_medium || "-"}
                                  </td>
                                );
                              if (col.name === "UTM Campaign")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_campaign || "-"}
                                  </td>
                                );
                              if (col.name === "Certificate")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    {/* <Button style={{ cursor: 'pointer' }} onClick={() => handleUploadClick(item)}> Upload </Button> */}
                                    {item.more_invesment_count == 0 && (
                                      <Button
                                        className="btn__upload"
                                        onClick={() => handleUploadClick(item)}
                                      >
                                        <img src={iconUploadbtn} />{" "}
                                        <span>Upload</span>
                                      </Button>
                                    )}
                                  </td>
                                );

                              return null;
                            })}
                          </tr>

                          <tr className="hiddenRow">
                            <td
                              colspan="32"
                              style={{
                                padding: 0,
                                position: "sticky",
                                left: 0,
                              }}
                            >
                              <div
                                className={`accordian-body collapse ${
                                  expandedRowId === index ? "show" : "hide"
                                }`}
                                id={`TableRow${index}`}
                              >
                                {item.more_invesment?.length > 1 ? (
                                  <div className="table_accordion_row">
                                    <div
                                      className="table_accordion_col"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="etf_fieldset_row etf_fieldset_row_new">
                                        <fieldset className="fieldset_col three_rows_fieldset">
                                          <legend className="legend_title">
                                            Investment Details
                                          </legend>

                                          {item.more_invesment?.map(
                                            (subitem, i) => (
                                              <div
                                                className={`purification_fieldset_row ${
                                                  subitem.lasted_invesment
                                                    ? "clsActiveInvestor"
                                                    : ""
                                                }`}
                                              >
                                                <div className="input__group_redis">
                                                  <div className="input__group_redis_label">
                                                    Investor ID
                                                  </div>
                                                  <div className="input__group_redis_value">
                                                    {subitem.id}
                                                  </div>
                                                </div>

                                                <div className="input__group_redis">
                                                  <div className="input__group_redis_label">
                                                    Investment Amount
                                                  </div>
                                                  <div className="input__group_redis_value">
                                                    {subitem.investment_amount}
                                                  </div>
                                                </div>

                                                <div className="input__group_redis">
                                                  <div className="input__group_redis_label">
                                                    status
                                                  </div>
                                                  <div className="input__group_redis_value">
                                                    {subitem.status}
                                                  </div>
                                                </div>
                                                <div className="input__group_redis">
                                                  <div className="input__group_redis_label">
                                                    Payment
                                                  </div>
                                                  <div className="input__group_redis_value">
                                                    {subitem.payment}
                                                  </div>
                                                </div>

                                                <div className="input__group_redis">
                                                  <div className="input__group_redis_label">
                                                    Created At
                                                  </div>
                                                  <div
                                                    className={`input__group_redis_value`}
                                                  >
                                                    {subitem.created_at}
                                                  </div>
                                                </div>

                                                <div className="input__group_redis_label">
                                                  <Button
                                                    className="btn__upload"
                                                    onClick={() =>
                                                      handleUploadClick(subitem)
                                                    }
                                                  >
                                                    <img src={iconUploadbtn} />{" "}
                                                    <span>Upload</span>
                                                  </Button>
                                                </div>

                                                <div className="">
                                                  <Whisper
                                                    placement="left"
                                                    trigger="click"
                                                    speaker={renderSpeaker}
                                                    open3={open}
                                                    onOpenChange={(nextOpen) =>
                                                      setOpen3(nextOpen)
                                                    }
                                                  >
                                                    <Button className="clsInvestorDelete">
                                                      <i className="icon-delete" />
                                                    </Button>
                                                  </Whisper>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </fieldset>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div className="table_accordion_row">
                                      <div
                                        className="table_accordion_col"
                                        style={{ width: "100%" }}
                                      >
                                        <div className="etf_details_row pb-2">
                                          <h4>No History Found</h4>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        </>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {reportCount > 1 && renderPagination()}
            </>
          )}
        </div>
      </div>

      {/* <Modal
        open={EditModalOpen}
        onClose={handleEditModalClose}
        className="edit_status_modal"
      >
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">
            {editModalETFName}
          </Modal.Title>
          <p>Re-Assign User</p>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <label>Select IR User</label>
              <div className="select_edit_status">
                <SelectPicker
                  data={userData}
                  searchable={true}
                  style={{ width: "100%" }}
                  placeholder="Select IR User"
                  onChange={handleUserChange}
                  value={assignUserid}
                  renderMenuItem={(label, item) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Avatar
                        circle
                        src={item.profile_img}
                        style={{ width: 30, height: 30 }}
                      />
                      <span>{label}</span>
                    </div>
                  )}
                />
              </div>
            </div>

            <div className="edit_status_field mt-4">
              <label>
                Comment
                <Whisper
                  placement="top"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      You may optionally add a reason for assigning this task to
                      help provide clarity to the assigned user.
                    </Tooltip>
                  }
                >
                  <img src={Icon_info} />
                </Whisper>
              </label>
              <textarea
                row="3"
                className="form-control"
                value={assignUserComment}
                onChange={(e) => setAssignUserComment(e.target.value)}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button
              type="button"
              className="btn_cancel"
              onClick={handleEditModalClose}
            >
              Cancel
            </button>
            <Button
              className="btn__save"
              onClick={handleReassignSave}
              loading={isLoading}
            >
              Re-assign
            </Button>
          </div>
        </Modal.Footer>
      </Modal> */}

      <Modal
        open={EditModalOpen}
        onClose={handleEditModalClose}
        className="edit_status_modal dual_modal_wrap"
      >
        <Modal.Body>
          <div className="dual_modal_row">
            {/* If count = 0 then add this to left col : style={{maxWidth:740, marginLeft:'auto', marginRight:'auto'}} */}
            <div
              className="dual_modal_col dual_modal_left_col"
              style={
                reassignCount === 0
                  ? { maxWidth: 740, marginLeft: "auto", marginRight: "auto" }
                  : {}
              }
            >
              <Modal.Header className="edit_modal_header">
                <Modal.Title className="edit_modal_title">
                  Re-Assign User
                </Modal.Title>
              </Modal.Header>
              <div className="edit_modal_content">
                <div className="edit_status_field">
                  <label>Select IR User</label>
                  <div className="select_edit_status">
                    <SelectPicker
                      data={userData}
                      searchable={true}
                      style={{ width: "100%" }}
                      placeholder="Select IR User"
                      onChange={handleUserChange}
                      value={assignUserid}
                      renderMenuItem={(label, item) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Avatar
                            circle
                            src={item.profile_img}
                            style={{ width: 30, height: 30 }}
                          />
                          <span>{label}</span>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="edit_status_field mt-4">
                  <label>
                    Comment
                    <Whisper
                      placement="top"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={
                        <Tooltip>
                          You may optionally add a reason for assigning this
                          task to help provide clarity to the assigned user.
                        </Tooltip>
                      }
                    >
                      <img src={Icon_info} />
                    </Whisper>
                  </label>
                  <textarea
                    row="3"
                    className="form-control"
                    value={assignUserComment}
                    onChange={(e) => setAssignUserComment(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="modal_footer_edit_status">
                <div className="btn__group">
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={handleEditModalClose}
                  >
                    Cancel
                  </button>
                  <Button
                    className="btn__save"
                    onClick={handleReassignSave}
                    loading={isLoading}
                  >
                    Re-assign
                  </Button>
                </div>
              </div>
            </div>

            {/* If count = 0 then add this to left col : style={{display:'none'}} */}
            <div
              className="dual_modal_col dual_modal_right_col"
              style={reassignCount === 0 ? { display: "none" } : {}}
            >
              <Modal.Header className="edit_modal_header">
                <Modal.Title className="edit_modal_title">
                  Assign History
                </Modal.Title>
              </Modal.Header>
              <div className="company_table_list table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Previous User</th>
                      <th>Current User</th>
                      <th>Assigned By</th>
                      <th>Assigned On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reassignHistory.map((item, index) => (
                      <tr key={index}>
                        <td>{item.old_user_name}</td>
                        <td>{item.new_user_name}</td>
                        <td>{item.updated_by_name}</td>
                        <td style={{ color: "#777" }}>{item.updated_at}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal open={EditModalOpen} onClose={handleEditModalClose}
        className="edit_status_modal modal_vflex_end slide-from-right"
        placement="right"
        transition
      >
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">Update Waiting List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <div class="duplicate_form_row">
                <div class="duplicate_form_col">
                  <label>Phone Number</label>
                  <input type='text' placeholder='Enter Number' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Country</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Country Residence"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Preferred Language</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Language"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Opt-In Consent</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Opt-In Consent"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Inv. Int. Amount</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Int. Amount"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Est. Inv. Timeline</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Timeline"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Accredited Investor Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Acc. Inv. Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Investor Type</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Investor Type"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Investment Likelihood Score</label>
                  <input type='text' placeholder='Inv. Likelihood Score' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col" style={{ width: '100%' }}>
                  <label>IR Notes</label>
                  <textarea className='form-control' placeholder='Notes' rows={3} style={{ height: 'auto' }}></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
            <button className="btn__save" onClick={handleManualSave}>Update</button>
          </div>
        </Modal.Footer>
      </Modal> */}

      <Drawer
        open={open2}
        onClose={handleCloseDrawer}
        size="xs"
        placement="left"
        className="show_hide_drawer"
      >
        <Drawer.Header>
          <Drawer.Title>Show & Hide Columns</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <div style={{ marginTop: 30 }}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {Object.entries(checkboxColumnMap).map(([id, columnName]) => (
                <div className="form-check" key={id}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={id}
                    checked={columnOrder.some((col) => col.name === columnName)} // ✅ fix here
                    onChange={(e) =>
                      handleCheckboxChange(columnName, e.target.checked)
                    }
                  />
                  <label className="form-check-label" htmlFor={id}>
                    {columnName}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Drawer.Body>
        <Drawer.Footer>
          <Button
            className="btn__cancel"
            style={{ width: "100%", background: "#FFF" }}
            onClick={handleReset}
          >
            Reset
          </Button>
        </Drawer.Footer>
      </Drawer>

      <Modal
        open={commentBoxOpen}
        onClose={handleCommentBoxClose}
        className="comment_modal_body"
        style={{ right: 0 }}
      >
        {renderMessage1()}
        {commentLoading ? (
          <div style={{ backgroundColor: "white", height: "100vh" }}>
            <Placeholder.Paragraph rows={8} />
            <Loader center content={commentLoading} />
          </div>
        ) : (
          <>
            <Modal.Header className="comment_modal_header">
              <Modal.Title className="comment_modal_title">
                {commentFetchTextValue}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="comment_modal_content">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h4 className="mb-3">
                    Comments({commentCount}
                    {})
                  </h4>
                  <div className="">
                    <h6
                      style={{
                        fontSize: 13,
                        color: "#666",
                        textAlign: "right",
                      }}
                    >
                      Invite Time:{" "}
                      <span style={{ fontSize: 13, color: "#000" }}>
                        {dateInvited}
                      </span>
                    </h6>
                    <h6
                      style={{
                        fontSize: 13,
                        color: "#666",
                        textAlign: "right",
                      }}
                    >
                      Time to First Contact:{" "}
                      <span
                        style={{
                          fontSize: 13,
                          color: "#000",
                          fontWeight: 500,
                          marginLeft: 6,
                        }}
                      >
                        <span
                          className={`time_fcontact_circle ${
                            colorCode === "green"
                              ? "time_fcontact_circle_green"
                              : colorCode === "yellow"
                              ? "time_fcontact_circle_yellow"
                              : colorCode === "orange"
                              ? "time_fcontact_circle_orange"
                              : colorCode === "red"
                              ? "time_fcontact_circle_red"
                              : ""
                          }`}
                        ></span>
                        <span>{firstTimeToContact}</span>
                      </span>
                    </h6>
                  </div>
                </div>
                {commentdata && commentdata.length === 0 ? (
                  <div className="zero_comment">
                    <img src={IconNoComment} />
                    <p>No Comments yet</p>
                  </div>
                ) : (
                  commentdata &&
                  commentdata.map((item, index) => (
                    <div className="comment_modal_box">
                      <div className="flex_sp_row comment_modal_box_top">
                        <h5>By {item.full_name}</h5>
                        <div className="comment_date">{item.created_at}</div>
                      </div>

                      <div className="flex_sp_row comment_modal_box_bottom clsOneline">
                        <p
                          dangerouslySetInnerHTML={{ __html: item.comment }}
                        ></p>
                        <a
                          href="javascript:void(0);"
                          className="cdelete_icon"
                          onClick={() => deleteComment(item)}
                        >
                          <i className="icon-delete"></i>
                        </a>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="modal_footer_comment_form">
              <div className="modal_footer_comment_inner">
                <div className="mt-3">
                  <label className="label_form">Comment</label>
                  {/* <input type='text' className='form-control' placeholder='Enter your comment' id="txtComment" /> */}
                  <textarea
                    className="form__control textarea_resisable"
                    placeholder="Enter your comment"
                    id="txtComment"
                  ></textarea>
                </div>

                <div className="btn__group">
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={handleCommentBoxClose}
                  >
                    Close
                  </button>
                  <Button
                    className="btn_comment"
                    onClick={() => addComment()}
                    loading={addCommentLoader}
                  >
                    Add Comment
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>

      <div
        className={`modal fade upload_file_modals ${
          showUploadManualModal ? "d-block show" : "d-none"
        }`}
        id="UploadFileModal"
        tabIndex="-1"
        aria-labelledby="UploadFileModalLabel"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: 760 }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title fs-5">
                Upload Files For {`LD` + -selectedFileInvestorId}
              </h4>
              <p>
                Add your documents here, and you can upload up to 30 MB files
                max
              </p>
            </div>
            <div className="modal-body">
              <div className="upload_section_main">
                <Uploader
                  action=""
                  draggable
                  // multiple // Allow multiple files
                  listType="text"
                  accept=".jpg,.png,.pdf"
                  // onChange={(files) => files.forEach((file) => handleFileSelect(file))}
                  onChange={(files) => {
                    if (uploadedfileList.length > 0) {
                      toast({
                        description:
                          "Only one file is allowed. Please delete the existing file before uploading a new one.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom",
                      });
                      return;
                    }

                    if (files.length > 1) {
                      toast({
                        description: "Please upload only one file at a time.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom",
                      });
                      return;
                    }

                    const file = files[0];
                    handleFileSelect(file);
                  }}
                  //defaultFileList={fileList1}
                  fileList={uploadedfileList}
                  fileListVisible={false} // file list visible nahi hogi.
                  //onRemove={handleRemove}
                >
                  <div>
                    <div className="upload_section">
                      <img src={iconUpload} alt="Upload Icon" />
                      <p>Drag your file(s) to start uploading</p>
                      <div className="or__text">
                        <span>OR</span>
                      </div>
                      <span className="btn__browse__file">Browse files</span>
                    </div>
                    <h6 style={{ marginBottom: 10 }}>
                      Only support .jpg, .png, .pdf and files
                    </h6>
                  </div>
                </Uploader>

                <div className="customUploadwrap">
                  {uploadedfileList.map((file) => {
                    const percent = progress[file.name] || 101;
                    const elapsedTime = (Date.now() - file.startTime) / 1000; // in seconds
                    const estimatedTimeRemaining =
                      percent > 0
                        ? Math.max(((100 - percent) * elapsedTime) / percent, 1)
                        : 0;

                    return (
                      <div key={file.id} className="customUploadList">
                        {percent < 100 ? (
                          // **Uploading Section**
                          <div>
                            <div className="progress_row">
                              <div className="progress_text">
                                <h4>Uploading...</h4>
                                <p>
                                  {percent}%{" "}
                                  <span>
                                    {" "}
                                    • {Math.round(estimatedTimeRemaining)}{" "}
                                    seconds remaining
                                  </span>
                                </p>
                              </div>
                            </div>
                            <Progress.Line
                              percent={percent}
                              showInfo={false}
                              strokeColor="#2B3779"
                            />
                          </div>
                        ) : (
                          // **Uploaded Section**
                          <div className="customUploadProgress_row">
                            <div className="filename_row">
                              <div
                                className="class_icon"
                                style={{ cursor: "pointer" }}
                              >
                                {/* <Link  to={file.type === "pdf" ? `https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}` : file.url} target="_blank" rel="noopener noreferrer"> */}
                                <img
                                  src={
                                    file.type == "pdf"
                                      ? iconPDF
                                      : file.type == "png"
                                      ? iconPNG
                                      : iconJPG
                                  }
                                  onClick={() => handlePreviewClick(file)}
                                />
                                {/* </Link> */}
                              </div>
                              <div className="class_filename">
                                <h5>{file.name}</h5>
                                <span className="file_size">
                                  {file.size} -{file.id}
                                </span>
                              </div>
                            </div>
                            <button
                              className="cls_btn_cross"
                              onClick={() => handleRemove(file)}
                            >
                              <img src={iconCancel} />
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="btn__group mt-5">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={closeUploadManualModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class={`modal fade upload_file_modal ${
          showUploadpreviewModal ? "d-block show" : "d-none"
        }`}
        id="ModalManualReport"
        tabindex="-1"
        aria-labelledby="AddNewAnalystModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              onClick={closeUploadpreviewModal}
            ></button>
            <div class="modal-body">
              {reportType === "pdf" ? (
                <iframe
                  title="LR Report PDF"
                  width="100%"
                  height="550"
                  src={preview}
                  className="iframe_pdf"
                ></iframe>
              ) : (
                <div className="upload_img_modal">
                  <img src={preview} alt="Preview" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={userActivityOpen}
        onClose={handleUserActivityClose}
        className="modal fade log_activity_call_modal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleUserActivityClose}
            ></button>
            <div className="activity_modal_body_header">
              <ul className="log_activity_tabs">
                <li
                  className={` ${activeTab === "log" ? "active" : ""}`}
                  onClick={() => setActiveTab("log")}
                >
                  {" "}
                  Log Activity{" "}
                </li>
                <li
                  className={` ${activeTab === "history" ? "active" : ""}`}
                  onClick={() => setActiveTab("history")}
                >
                  History
                </li>
              </ul>
              <div className="activity_modal_body_header_right">
                <p>Assigned To</p>
                <div className="log_activity_select">
                  <SelectPicker
                    data={userData}
                    searchable={true}
                    style={{ width: 300 }}
                    placeholder="Select IR User"
                    value={assignUserid}
                    menuClassName="log_activity_select_dropdown"
                    container={() => document.querySelector(".modal-body")}
                    renderMenuItem={(label, item) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Avatar
                          circle
                          src={item.profile_img}
                          style={{ width: 30, height: 30 }}
                        />
                        <span>{label}</span>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <div class="modal-body log_activity_call_modal_body"ref={modalBodyRef}>
              {activeTab === "log" && (
                <div className="tab_content_section">
                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">
                      {" "}
                      Status & Timing{" "}
                    </div>
                    <p>
                      Investor:{" "}
                      <span className="dark__grey__text">
                        {activityData?.investor}
                      </span>
                    </p>
                    <p>
                      Invited At:{" "}
                      <span className="dark__grey__text">
                        {activityData?.invited_at}
                      </span>
                    </p>
                    <p>
                      Investor's Local Time:{" "}
                      <span
                        className="dark__grey__text"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <LiveTimeCell timezone={activityData?.time_zone} />{" "}
                        {activityData?.country_name &&
                          `(${activityData.country_name})`}
                      </span>
                    </p>
                    <p>
                      Time Since Invite:{" "}
                      {activityData?.is_locked === 1 ? (
                        <>
                          <span className={colorClass}>
                            {activityData?.time_to_first_contact}
                          </span>
                          <span className={dotClass}></span>
                        </>
                      ) : elapsed ? (
                        <>
                          <span className={colorClass}>{elapsed}</span>
                          <span className={dotClass}></span>
                        </>
                      ) : (
                        <span className="skeleton-loader"></span>
                      )}
                    </p>

                    <p>
                      Escalation Status:
                      <span className="dark__grey__text">
                        {colorClass === "dark__green__text" &&
                          " On Track (within 5-minute SLA)"}
                        {colorClass === "dark__orange__text" &&
                          " At Risk (over 5 minutes)"}
                        {colorClass === "dark__red__text" &&
                          " Escalated (over 10 minutes)"}
                      </span>
                    </p>

                    <div className="reason_notify_row">
                      {totalMinutes >= 10 ? (
                        <p>
                          <span className="triangle__shape triangle__red"></span>{" "}
                          Escalation Triggered{" "}
                          <span>– No contact after 10 minutes</span>
                        </p>
                      ) : totalMinutes >= 5 ? (
                        <p>
                          <span className="triangle__shape triangle__orange"></span>{" "}
                          Risk: <span>Investor may not invest anymore</span>
                        </p>
                      ) : null}

                      <p>
                        {" "}
                        Action:{" "}
                        <span>
                          Add reason for delay and notify manager
                        </span>{" "}
                      </p>

                      {totalMinutes >= 5 ? (
                        <>
                          <div className="reason_notify_btn__group">
                            {" "}
                            <button
                              className="btn__reason_for_delay"
                              onClick={handleReasonClick}
                            >
                              {" "}
                              Reason for Delay{" "}
                            </button>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  This feature is currently unavailable. It will
                                  be available in V2.
                                </Tooltip>
                              }
                            >
                              <button className="btn__notify_manager">
                                Notify Manager
                              </button>
                            </Whisper>
                          </div>

                          <div
                            className={`${
                              isReasonActive
                                ? "clsReasonDelay active mt-4"
                                : "clsReasonDelay mt-4"
                            }`}
                          >
                            <label>Reason</label>
                            <textarea
                              rows={3}
                              className="form-control textarea_form_log_activity"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            ></textarea>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>

                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">
                      Investor Snapshot
                    </div>
                    <p>
                      Investor Status:{" "}
                      <span className="dark__grey__text">
                        {activityData?.investor_status ?? "N/A"}
                      </span>
                    </p>

                    <p>
                      Accredited Status:{" "}
                      <span className="dark__grey__text">
                        {activityData?.accredited_status ?? "N/A"}
                      </span>
                    </p>

                    <p>
                      Investment Likelihood Score:{" "}
                      <span className="dark__grey__text">
                        {activityData?.likelihood_score ?? "N/A"}
                      </span>
                      {Number(activityData?.likelihood_score) >= 70 && (
                        <span className="green__dot"></span>
                      )}
                    </p>

                    <p>
                      Subscription Type:{" "}
                      <span className="dark__grey__text">
                        {activityData?.subscription_type ?? "N/A"}
                      </span>
                    </p>

                    <p>
                      Days Since Subscription:{" "}
                      <span className="dark__grey__text">
                        {activityData?.days_since_subscription ?? "N/A"}
                      </span>
                    </p>

                    <p>
                      Activity Score:{" "}
                      <span className="dark__grey__text">
                        {activityData?.activity_score ?? "N/A"}
                      </span>
                      {Number(activityData?.activity_score) >= 70 && (
                        <span className="green__dot"></span>
                      )}
                      <span className="modal_icon__info">
                        <img src={IconInfo1} alt="info" />
                      </span>
                    </p>
                  </div>

                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">
                      Communication Details
                    </div>
                    <ul className="log_activity_CD_tabs">
                      <li className="active">Call</li>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            This feature is currently unavailable. It will be
                            available in V2.
                          </Tooltip>
                        }
                      >
                        <li>SMS</li>
                      </Whisper>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            This feature is currently unavailable. It will be
                            available in V2.
                          </Tooltip>
                        }
                      >
                        <li>Whats App</li>
                      </Whisper>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            This feature is currently unavailable. It will be
                            available in V2.
                          </Tooltip>
                        }
                      >
                        <li>Email</li>
                      </Whisper>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            This feature is currently unavailable. It will be
                            available in V2.
                          </Tooltip>
                        }
                      >
                        <li>Meeting</li>
                      </Whisper>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            This feature is currently unavailable. It will be
                            available in V2.
                          </Tooltip>
                        }
                      >
                        <li>Other</li>
                      </Whisper>
                    </ul>

                    <div className="row">
                      <div className="col-md-4 mt-4">
                        <label>Call Type</label>
                        <div className="log_activity_select">
                          <SelectPicker
                            data={callTypeOptions}
                            searchable={false}
                            style={{ width: "100%" }}
                            placeholder="Select Type"
                            value={callTypeId}
                            onChange={handleCallTypeChange}
                            menuClassName="log_activity_select_dropdown"
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mt-4">
                        <label>Status</label>
                        <div className="log_activity_select">
                          <SelectPicker
                            data={callStatusOptions}
                            searchable={false}
                            style={{ width: "100%" }}
                            placeholder="Select Status"
                            value={callStatusId}
                            onChange={handleCallStatusChange}
                            menuClassName="log_activity_select_dropdown"
                            renderMenuItem={(label, item) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span
                                  style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: item.color,
                                  }}
                                ></span>
                                <span>{label}</span>
                              </div>
                            )}
                            renderValue={(value, item) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span
                                  style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: item?.color,
                                  }}
                                ></span>
                                <span>{item?.label}</span>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">
                      Outcome & Follow-Up
                    </div>
                    <div className="row">
                      <div className="col-md-12 mt-4">
                        <label>Interaction Summary</label>
                        <textarea
                          rows={3}
                          className="form-control textarea_form_log_activity"
                          value={interactionSummary}
                          onChange={(e) =>
                            setInteractionSummary(e.target.value)
                          }
                        ></textarea>
                      </div>

                      <div className="col-md-6 mt-4">
                        <label>Outcome</label>
                        <div className="log_activity_select">
                          <SelectPicker
                            data={outcomeOptions}
                            searchable={false}
                            style={{ width: "100%" }}
                            placeholder="Select Outcome"
                            value={selectedOutcome}
                            onChange={setSelectedOutcome}
                            menuClassName="log_activity_select_dropdown"
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mt-4">
                        <label>Priority Level</label>
                        <div className="log_activity_select">
                          <SelectPicker
                            data={priorityOptions}
                            searchable={false}
                            style={{ width: "100%" }}
                            placeholder="Select Priority"
                            value={selectedPriority}
                            onChange={setSelectedPriority}
                            menuClassName="log_activity_select_dropdown"
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mt-4">
                        <label>Initial Investment Interest Amount</label>
                        <div className="log_activity_select cutom_input_with_info cutom_input_with_info_disabled">
                          <input
                            type="text"
                            value={activityData?.investment_amount}
                          />
                          <button>
                            <img src={IconInfo1} />
                          </button>
                        </div>
                      </div>

                      <div className="col-md-6 mt-4">
                        <label>Updated Investment Interest Amount</label>
                        <div className="log_activity_select cutom_input_with_btn">
                          <input
                            type="text"
                            className=""
                            value={investmentInterestAmount}
                            onChange={handleInvestmentChange}
                          />
                          <button>Results</button>
                        </div>
                      </div>

                      <div className="col-md-6 mt-4">
                        <label>Follow-Up Plan</label>
                        <input
                          type="text"
                          className="form-control log_activity_select log_activity_input_italic"
                          placeholder="Type here"
                          value={followUpPlan}
                          onChange={handleFollowUpChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">
                      Notes & Scheduling
                    </div>
                    <div className="log_activity_calendar_row">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ScheduleFollowUp"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="ScheduleFollowUp"
                        >
                          Schedule Follow-Up
                        </label>
                      </div>

                      <div className="log_activity_select log_activity_calendar">
                        <DatePicker
                          oneTap
                          showMeridian
                          style={{ width: "100%" }}
                          placeholder="Choose Date"
                          format="dd-MM-yyyy"
                          value={followUpDate}
                          onChange={(value) => {
                            setFollowUpDate(value);
                          }}
                        />
                      </div>

                      <div className="log_activity_select log_activity_calendar">
                        <input type="text" readOnly />
                      </div>

                      {/* <a href='#' className=''>Attach Supporting Materials</a> */}
                    </div>

                    {/* <a href='#' className='mt-4'>Attach Supporting Materials</a> */}
                  </div>

                  <div className="log_activity_call_section">
                    <div className="log_activity_call_title">System Info</div>
                    <div className="text_create_and_modify">
                      <p>
                        <span>Created By:</span>{" "}
                        {activityData?.created_by || "N/A"}
                      </p>
                      <p>
                        <span>Last Modified By:</span>{" "}
                        {activityData?.last_modified_by || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "history" && (
                <div className="tab_content_section tab_content_section_history">
                  {/* Upcoming & Overdue Section */}
                  {"Upcoming & Overdue" in historyData && (
                    <div className="tab_content_section_history_wrap">
                      <div
                        className="history_section_title d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleMonth("Upcoming & Overdue")}
                      >
                        Upcoming & Overdue
                        <span>
                          <img
                            style={{ transition: "transform 0.3s ease" }}
                            src={
                              expandedMonths.includes("Upcoming & Overdue")
                                ? iconDropArrow
                                : iconCollapseArrow
                            }
                            alt="toggle"
                            width={20}
                            height={20}
                          />
                        </span>
                      </div>

                      <div
                        className={`entry-container transition-container ${
                          expandedMonths.includes("Upcoming & Overdue")
                            ? "expanded"
                            : ""
                        }`}
                      >
                        {historyData["Upcoming & Overdue"]?.length > 0 ? (
                          historyData["Upcoming & Overdue"].map(
                            (entry, idx) => {
                              const isExpanded =
                                expandedItems["Upcoming & Overdue"]?.[idx];
                              return (
                                <div
                                  key={idx}
                                  className="border-startX border-2 ps-3 position-relative history_main_row"
                                  style={{
                                    borderLeft: `2px solid ${
                                      typeColors[entry.type] || "#ccc"
                                    }`,
                                  }}
                                >
                                  {/* Timeline marker */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: -2,
                                      left: -53,
                                      width: 80,
                                      height: 55,
                                      background: "#FFF",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "start",
                                      gap: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      toggleItem("Upcoming & Overdue", idx)
                                    }
                                  >
                                    <span style={{ fontSize: 14 }}>
                                      <img
                                        style={{
                                          transition: "transform 0.3s ease",
                                        }}
                                        src={
                                          isExpanded
                                            ? iconDropArrow
                                            : iconCollapseArrow
                                        }
                                        alt="toggle"
                                        width={20}
                                        height={20}
                                      />
                                    </span>
                                    <img
                                      src={icons[entry.type]}
                                      alt={entry.type}
                                      width={50}
                                      height={50}
                                      style={{ objectFit: "contain" }}
                                    />
                                  </div>

                                  <div className="history_under_tab d-flex justify-content-between">
                                    <div style={{ width: "100%" }}>
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <div className="d-flex align-items-center gap-2">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={`checkbox-Upcoming-${idx}`}
                                              checked={
                                                entry.userChecked ??
                                                entry.rawData?.is_completed ??
                                                false
                                              }
                                              onChange={(e) => {
                                                const updated = [
                                                  ...historyData[
                                                    "Upcoming & Overdue"
                                                  ],
                                                ];
                                                updated[idx].userChecked =
                                                  e.target.checked;
                                                setHistoryData({
                                                  ...historyData,
                                                  "Upcoming & Overdue": updated,
                                                });

                                                // ✅ Auto-expand this item if checked
                                                if (e.target.checked) {
                                                  setExpandedItems((prev) => ({
                                                    ...prev,
                                                    ["Upcoming & Overdue"]: {
                                                      ...(prev[
                                                        "Upcoming & Overdue"
                                                      ] || {}),
                                                      [idx]: true,
                                                    },
                                                  }));
                                                }
                                              }}
                                            />

                                            <label
                                              htmlFor={`checkbox-Upcoming-${idx}`}
                                              className="history_under_head m-0"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                toggleItem(
                                                  "Upcoming & Overdue",
                                                  idx
                                                )
                                              }
                                            >
                                              {entry.type || "Follow-up"}
                                            </label>
                                          </div>
                                          <div className="text-muted history_under_desc">
                                            You have a follow-up task
                                          </div>
                                        </div>
                                        <div className="text-muted history_under_date">
                                          {entry.time}
                                        </div>
                                      </div>

                                      {/* Expanded content for follow-ups */}
                                      <div
                                        className={`expandable-wrapper ${
                                          isExpanded ? "open" : ""
                                        }`}
                                      >
                                        {isExpanded && (
                                          <>
                                            <div className="mt-3">
                                              <div className="medium_text mb-1">
                                                Notes:
                                              </div>

                                              <textarea
                                                className="form-control form__control__modal"
                                                rows={3}
                                                value={
                                                  entry.userNote ??
                                                  entry.rawData
                                                    .follow_up_note ??
                                                  ""
                                                }
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...historyData[
                                                      "Upcoming & Overdue"
                                                    ],
                                                  ];
                                                  updated[idx].userNote =
                                                    e.target.value;
                                                  setHistoryData({
                                                    ...historyData,
                                                    "Upcoming & Overdue":
                                                      updated,
                                                  });
                                                }}
                                              />

                                              <div className="text-end mt-2">
                                                <button
                                                  className="btn__save_log_checkbox"
                                                  onClick={() =>
                                                    handleSaveFollowUp(
                                                      entry,
                                                      idx
                                                    )
                                                  }
                                                >
                                                  Save
                                                </button>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                        ) : (
                          <div className="text-center py-3 text-muted">
                            No upcoming follow-ups scheduled
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* History by Month */}
                  {Object.entries(historyData)
                    .filter(([month]) => month !== "Upcoming & Overdue")
                    .map(([month, entries]) => (
                      <div
                        key={month}
                        className="tab_content_section_history_wrap"
                      >
                        <div
                          className="history_section_title d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleMonth(month)}
                        >
                          {month}
                          <span>
                            <img
                              style={{ transition: "transform 0.3s ease" }}
                              src={
                                expandedMonths.includes(month)
                                  ? iconDropArrow
                                  : iconCollapseArrow
                              }
                              alt="toggle"
                              width={20}
                              height={20}
                            />
                          </span>
                        </div>

                        <div
                          className={`entry-container transition-container ${
                            expandedMonths.includes(month) ? "expanded" : ""
                          }`}
                        >
                          {entries.map((entry, idx) => {
                            const isExpanded = expandedItems[month]?.[idx];
                            return (
                              <div
                                key={idx}
                                className="border-startX border-2 ps-3 position-relative history_main_row"
                                style={{
                                  borderLeft: `2px solid ${
                                    typeColors[entry.type] || "#ccc"
                                  }`,
                                }}
                              >
                                {/* Timeline marker */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: -2,
                                    left: -53,
                                    width: 80,
                                    height: 55,
                                    background: "#FFF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    gap: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleItem(month, idx)}
                                >
                                  <span style={{ fontSize: 14 }}>
                                    <img
                                      style={{
                                        transition: "transform 0.3s ease",
                                      }}
                                      src={
                                        isExpanded
                                          ? iconDropArrow
                                          : iconCollapseArrow
                                      }
                                      alt="toggle"
                                      width={20}
                                      height={20}
                                    />
                                  </span>
                                  <img
                                    src={icons[entry.type]}
                                    alt={entry.type}
                                    width={50}
                                    height={50}
                                    style={{ objectFit: "contain" }}
                                  />
                                </div>

                                <div className="history_under_tab d-flex justify-content-between">
                                  <div style={{ width: "100%" }}>
                                    <div className="d-flex justify-content-between">
                                      <div
                                        className="history_under_head"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleItem(month, idx)}
                                      >
                                        {entry.type}
                                      </div>
                                      <div className="text-muted history_under_date">
                                        {entry.time}
                                      </div>
                                    </div>
                                    <div className="text-muted history_under_desc">
                                      {`You had ${entry.type.toLowerCase()}`}
                                    </div>

                                    {/* Expanded content for history entries */}
                                    <div
                                      className={`expandable-wrapper ${
                                        isExpanded ? "open" : ""
                                      }`}
                                    >
                                      {isExpanded && entry.rawData && (
                                        <>
                                          <div className="mt-4 d-flex gap-4">
                                            <div className="history_date">
                                              <span className="medium_text">
                                                Started:
                                              </span>
                                              {formatDateTime(
                                                entry.rawData.created_at
                                              )}
                                            </div>
                                            {entry.rawData.updated_at && (
                                              <div className="history_date">
                                                <span className="medium_text">
                                                  Ended:
                                                </span>
                                                {formatDateTime(
                                                  entry.rawData.updated_at
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          {entry.rawData.summary ? (
                                            <div className="mt-3">
                                              <div className="medium_text mb-1">
                                                Call Notes:
                                              </div>
                                              <div className="form-control form__control__modal readonly-notes">
                                                {entry.rawData.summary}
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="text-muted mt-3">
                                              No notes available for this call
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>

            <div class="modal-footer">
              <button
                type="button"
                className="btn_cancel_log_activity"
                onClick={handleUserActivityClose}
              >
                {" "}
                Cancel{" "}
              </button>
              <Button
                className="btn__save_log_activity"
                onClick={handleSaveLogActivity}
                loading={saveLoading}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Leads;
